import React, { Fragment, useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import { connect } from 'react-redux';
import Delayed from '../../../atoms/deleyad';
import { generateBoard } from '../../../../services/raphaelJsService';
import Transaction from './Transactions';
//for restructuring
import { checkValidConnection } from '../../../../store/constructs/clusterlet_connections/selectors';
import { getTransaction, getAllTransactions } from '../../../../store/constructs/transactions/selectors';
import { getSelectedTransactions } from '../../../../store/constructs/transactions/selectors';
import { setSelectedTransactionId, setFocusElement, toggleRightDrawer, setIsDocumentClicked } from '../../../../store/global/actions';
import { getAllEvents } from '../../../../store/constructs/events/selectors';
import { getEvents } from '../../../../store/constructs/events/selectors';
import { getNestedTransactions } from '../../../../store/constructs/transactions/selectors';
import { getBorderElement, getPreviousElement } from '../../../../services/raphaelJsService';
import { getSelectedEvent, getRenderCount, getRightDrawerStatus, getTransactionState, getDisablePanStatus, getCodeEditStatus } from '../../../../store/global/selectors';
import { nestedTransactionConfig, nestedTransactionLabelConfig, invokedTransactionConfig, labelAttributes, eventAttributes, drawingTrackingTransactionConfig, templatedTransactionConfig, translabelAttributes, dragHandler, backRect, eventAttributes1, nestedOneofTransactionConfig, nestedConditionalTransactionConfig, nestedLoopTransactionConfig, conditionalEventLabelConfig } from '../../../../config/clusterlets';
import { glowSettings } from '../../../../config/styles';
import { handleSnackBar, reRenderInfoBuilder, setTabOnFocus, setDrawEvent, setDrawNestedTransaction, setDrawReuseTransaction, setDrawTemplateTransaction, setDrawnTransaction, setDisablePan } from '../../../../store/global/actions';
import TransactionSpeedDial from '../../../pages/blueprint/TransactionSpeedDial';
import DisableDrawingModeButton from '../../../pages/blueprint/DisableDrawingModeButton';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import TransactionZoomOptions from '../../../pages/blueprint/TransactionZoomOptions';
import { getTemplateClusterlets } from '../../../../store/constructs/templated_clusterlet/selectors';
import { getBlueprintData } from '../../../../services/blueprint';
import { useParams } from 'react-router-dom';
import Requester from '../../../../store/blueprint/svc';
import { invokePostService, invokeGetService, setReRender, handleTopRightInfo, setInnerScreenRender, setNestedTransactionEvents, setNestedTransactionClusterlets, setNestedTransactionChildren, setNestedTransactionInvoked, setParentTransaction } from '../../../../store/global/actions';
import { getReRender } from '../../../../store/global/selectors';
import LoaderWithProgress from '../../../atoms/loader/LoaderWithProgress';
import { useHistory } from 'react-router-dom';
import { findNearestValues } from '../../../../services/entities/common';
import { isRectangleContained } from '../../../../utils/drawingUtils';

const fetch = new Requester();

const { Raphael } = require('react-raphael');
const { default: ImgGrid } = require('./images/grid.gif');

//const { default: PencilIcon } = require("./images/pencil.png");

const uuid = require('short-uuid');
const log = console.log;

class App extends React.Component {
  constructor(props) {
    super(props);
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);

    this.state = {
      width: vw || window.innerWidth - (64 + 175),
      height: vh - 42 || window.innerHeight - (64 + 48 + 30),
      arrow: { mouseDown: {} },
      arrowPayload: null,
      codeEditorView: false,
      anchorEl: null,
      panDisable: false,
    };
    this.paper = null;
    this.startingPoints = [];
    this.arrowAllowedYValue = 100;
    this.arrowPayloadRef = {};
    this.widthOfRectangle = 150;
    this.heightOfRectangle = 70;
    this.drawnRectangles = [];
    this.selectedTransaction = {};
    this.transctionsList = [];
    this.raphaelPaper = null;
    this.drawnTexts = [];
    this.renderInProgress = false;
    this.handlerClusterlet = {};

    this.canvas = null;
    this.drawnClusterlets = [];
    this.yGap = this.heightOfRectangle + 50;
    this.verticalDifference = this.heightOfRectangle;
    this.eventLabelGap = 9;
    this.yGapNestedChildren = 20;
    this.yGapNestedTrans = 60;
    this.drawnChildTransactions = [];
    this.drawnChildInvokedTransactions = [];
    this.drawnChildNestedTransactions = [];
    this.drawnTemplatedTransactions = [];
    this.drawnEvents = [];
    this.drawnPaths = [];
    this.currentDrawnEvent = null;
    this.movingPath = null;
    this.zoom = 1;
    //this.panDisabled = false;
    this.lastDrawnY = null;
    this.drawnVerticalLines = [];
    this.eventGroup = [];
    this.nestedGroup = [];
    this.invokedGroup = [];
    this.eventPlotPoints = {
      startPoint: null,
      endPoint: null,
    };
    this.verticalLineCordinates = [];
    this.plotingMarker = null;
    this.moveListener = null;
    this.startPlotPoint = null;
    this.nearestValues = null;
    this.mousePositionX = 0;
    this.mouseDownPosition = 0;
    this.startXValue = 0;
    this.mosusePosY = 0;
    this.xPosOnStart = 0;
    this.initialEventParameters = {};
    this.prevChild = '';
    this.yDistance = this.heightOfRectangle + 50;
    this.connectedClusterletArray = [];
    this.initialNestedParameters = {};
  }

  componentDidMount() {
    // console.log('prps------->', this.props);
    this.props.dispatch(setDrawEvent(false));
    this.props.dispatch(setDrawNestedTransaction(false));
    this.props.dispatch(setDrawReuseTransaction(false));
    this.props.dispatch(setDisablePan(false));
    this.initiateDrawing();

    // this.props.dispatch(triggerTour({ currentTour: 'transactions' }))

    const zoomElement = document.getElementById('papercanvas');
    const ZOOM_SPEED = 0.1;
    const self = this;
  }

  handleCodeEditor = (value) => {
    this.setState({ codeEditorView: value ? true : false });
  };

  handleEmbeddedTransactionClick = (element, selectedEmebbedId) => {
    const { addEvent, addTransction } = this.props.eventViewProps;
    const mouseEnableCondition = addEvent;
    if (mouseEnableCondition) return;

    const { width, arrowPayload, codeEditorView, height } = this.state;
    const { eventViewProps } = this.props;
    if (!arrowPayload) {
      if (eventViewProps && eventViewProps.onToggle) eventViewProps.onToggleTranction(selectedEmebbedId);
    }
  };

  arrowTextPosition = (x1, x2) => {
    if (x2 > x1) return x1 + (x2 - x1) / 2;
    else return x2 + (x1 - x2) / 2;
  };

  arrowNodePosition = ({ src, dst }) => {
    const source = this.drawnRectangles.find((rect) => rect.id == src);
    const dest = this.drawnRectangles.find((rect) => rect.id == dst);

    return { x1: source.drawnObj.attr('x'), x2: dest.drawnObj.attr('x') };
  };

  handlerPosition = ({ src, dst, attributes: { onrev, onsend } }) => {
    let sourceNode = this.drawnRectangles.find((rect) => rect.id == src);
    let dstNode = this.drawnRectangles.find((rect) => rect.id == dst);

    let halfWidthOfRect = this.widthOfRectangle / 2;
    let startX = sourceNode.drawnObj.attr('x') + halfWidthOfRect;
    let endX = dstNode.drawnObj.attr('x') + halfWidthOfRect;

    return { onrev: endX, onsend: startX };
  };

  removePartialEvents = () => {
    if (this.currentDrawnEvent != null) {
      this.currentDrawnEvent.remove();
      this.currentDrawnEvent = null;
    }
  };

  drawArrow = (arrows) => {
    if (!(arrows && arrows.length)) return;

    let prevYPositions = [];

    arrows.forEach((arrow) => {
      this.drawSingleArrow(arrow);
    });
  };

  drawSingleArrow = (arrow) => {
    const self = this;
    const { onrev, onsend } = this.handlerPosition(arrow);

    //Draw arrow
    if (arrow.attr?.path !== undefined) delete arrow.attr.path;

    let {
      position: { x1, y1, x2, y2 },
    } = arrow;
    const start = this.arrowTextPosition(x1, x2);

    /** Calculations to adjust arrow balls vs handlers */
    let spaceToAdjustHandlerCircle = 18;
    let spaceToAdjustArrowHead = 5;

    if (arrow.attributes.onrecv) {
      x2 = x2 > x1 ? x2 - spaceToAdjustHandlerCircle : x2 + spaceToAdjustHandlerCircle;
    } else {
      x2 = x2 > x1 ? x2 - spaceToAdjustArrowHead : x2 + spaceToAdjustArrowHead;
    }

    let textY = y1;

    const aPath = `M${x1} ${y1}L${x2} ${y2}`;
    const element = self.paper.path(aPath);

    element.position = {
      x1: x1,
      x2: x2,
      y1: y1,
      y2: y2,
    };

    this.lastDrawnY = y1;

    element.attr(eventAttributes);
    element.hover(
      function () {
        this.data('glow', this.glow(glowSettings));
      },
      function () {
        this.data('glow').remove();
      },
    );

    element.node.setAttribute('data-ui-tour-id', 'df-event');


    const text = self.paper.text(start, textY - this.eventLabelGap, arrow.name).attr(labelAttributes);

    const srcNode = this.props.elements?.find((c) => c._id == arrow.src);
    const dstNode = this.props.elements?.find((c) => c._id == arrow.dst);
    let protocol = srcNode?.type == 1 ? srcNode?.attributes?.type : dstNode?.type == 1 ? dstNode?.attributes?.type : undefined;

    const focusElement = { id: arrow._id, type: 'event', name: arrow.name, item: arrow, mode: 'edit', protocol };
    if (arrow?.category) {
      focusElement['templateEvent'] = arrow;
    }

    text.click(function () {
      if (self.props.codeEditStatus) {
        // For alert to save when handler code is editing
        self.props.dispatch(setIsDocumentClicked());
        return;
      }
      
      self.removePartialEvents();
      // self.props.dispatch(setFocusElement({ id: arrow.id, type: 'event' }))
      self.props.dispatch(setFocusElement(focusElement));
      self.props.dispatch(setTabOnFocus(0));

      if (self.props.rightDrawerStatus == false) {
        self.props.dispatch(toggleRightDrawer());
      }
    });

    text.attr(labelAttributes);

    let box = text.getBBox();
    let rect = self.paper.rect(box.x - 10, box.y, box.width + 20, box.height)
    if (arrow.condition != undefined && arrow.condition != "") {
      rect.attr(conditionalEventLabelConfig);
    } else {
      rect.attr(nestedTransactionLabelConfig);
    }
    text.toFront();
    let backGroundRect = self.paper.rect(box.x - 30, box.y, 20, box.height).attr(backRect);

    let dragHandle = self.paper.image(`${process.env.PUBLIC_URL}/dragImage1.png`, box.x - 30, box.y, 20, box.height).attr(dragHandler);

    // var face1 = paper.set([mouth, eye1, eye2]);

    const elements = { element, text };

    element.click(function () {
      self.removePartialEvents();

      self.props.dispatch(setFocusElement(focusElement));
      if (self.props.rightDrawerStatus == false) {
        self.props.dispatch(setTabOnFocus(0));
        self.props.dispatch(toggleRightDrawer());
      }
    });

    //on-receive handler

    const elementObj = {
      event: { obj: element, id: arrow._id, y: y1 },
      label: { obj: text, id: text.id, y: text.attrs.y },
      box: { obj: rect, id: rect.id, y: rect.attrs.y },
      dragHandle: { obj: dragHandle, id: dragHandle.id, y: dragHandle.attrs.y },
      backRectangle: { obj: backGroundRect, id: backGroundRect.id, y: backGroundRect.attrs.y },
    };

    if (arrow.attributes.onrecv) {
      const onrevCircle = self.paper.circle(onrev, textY, 10, 10);
      const onRecvTabIndex = arrow?.category === 'template' ? 0 : 6;
      onrevCircle.attr({ cursor: 'pointer' });
      onrevCircle.attr('stroke', 'black');
      // onrevCircle.attr("fill", "blue");
      onrevCircle.attr('fill', '#6a7795');
      onrevCircle.attr('stroke-width', 2);
      onrevCircle.node.onclick = function () {
        self.props.dispatch(setFocusElement(focusElement));
        self.props.dispatch(setTabOnFocus(onRecvTabIndex));
        if (self.props.rightDrawerStatus == false) {
          self.props.dispatch(toggleRightDrawer());
        }
      };
      onrevCircle.hover(function () {
        this.attr('title', 'On-receive handler');
      });

      elementObj['onrecv'] = { obj: onrevCircle, id: onrevCircle.id };
    }

    //on-send handler
    if (arrow.attributes.onsend) {
      const onsendCicrcle = self.paper.circle(onsend, textY, 10, 10);
      const onSendTabIndex = arrow?.category === 'template' ? 0 : 5;
      onsendCicrcle.attr({ cursor: 'pointer' });
      // onsendCicrcle.attr("stroke", "blue");
      onsendCicrcle.attr('stroke', '#6a7795');
      onsendCicrcle.attr('fill', 'black');
      // onsendCicrcle.attr("fill", "#273e65");
      onsendCicrcle.attr('stroke-width', 2);
      onsendCicrcle.node.onclick = function () {
        self.props.dispatch(setFocusElement(focusElement));
        self.props.dispatch(setTabOnFocus(onSendTabIndex));
        if (self.props.rightDrawerStatus == false) {
          self.props.dispatch(toggleRightDrawer());
        }
      };

      onsendCicrcle.hover(function () {
        this.attr('title', 'On-send handler');
      });

      elementObj['onsend'] = { obj: onsendCicrcle, id: onsendCicrcle.id };
    }

    /**Store raphel info only if thats not templated event */
    if (arrow.category === undefined) {
      this.drawnEvents.push({ positionY: y1, id: arrow._id, path: element });
    }

    //this.drawnPaths.push( { id: arrow.id, path: element }) /* has to be optimized - use the same variable */

    // this.eventGroup.push({
    // event: { obj: element, id: arrow.id },
    // label: { obj: text, id: text.id },
    // box: { obj: rect, id: rect.id },

    // })
    this.eventGroup.push(elementObj);

    dragHandle.drag(
      (dx, dy, mx, my, e) => {
        self.labelDragInProgress(text, dx, dy, e);
      },
      (e) => {
        this.onStartDrag(text, e);
      },
      (e) => {
        self.labelDragEnd(text, self, e);
      },
    );
  };

  /** Find parent transaction of an event drawn */
  findEventParentTransaction = (arrow) => {
    let arrowX = arrow.position.y;
    let parentTransaction = this.drawnChildTransactions.find((t) => {
      return t.rect.attr('y') <= arrowX && arrowX <= t.height + t.y;
    });
    return parentTransaction;
  };

  handler = (attributes, identity) => {
    const { selected, eventViewProps } = this.props;
    const index = selected.embeddedTransactions.findIndex((i) => i.uuid == identity);
    selected.embeddedTransactions[index].attributes = attributes;
    if (eventViewProps && eventViewProps.setSelectedTransction) eventViewProps.setSelectedTransction(selected);
  };

  expandMinimiseEmbbeddedTransactions = (uuid) => {
    const { addEvent, addTransction } = this.props.eventViewProps;

    const mouseEnableCondition = addEvent || addTransction;

    if (mouseEnableCondition) return;

    const selected = { ...this.props.selected };
    const index = selected.embeddedTransactions.findIndex((i) => i.uuid === uuid);
    selected.embeddedTransactions[index] = {
      ...selected.embeddedTransactions[index],
      expanded: !selected.embeddedTransactions[index].expanded,
    };

    //this.props.dispatch(setSelectedTransction(selected));
    this.props.dispatch(setSelectedTransactionId(selected.id || this.props.transction[0].id));
  };

  onStart(e) {

    //this.setState({ disablePan: true });
    this.mouseDownPosition = this.mousePositionX;
    this.xPosOnStart = this.mosusePosY;

    this.disablePan();
  }

  onStartDrag(textObj, e) {
    let matchingGroup = this.eventGroup.find((group) => group.label.id == textObj.id);

    this.initialEventParameters = matchingGroup.event;


    this.mouseDownPosition = this.mousePositionX;
    this.xPosOnStart = this.mosusePosY;

    this.disablePan();
  }

  onMove(moveHandler, moveHandlerText, rect, verticalLine, dx, dy, e) {
    let mouseGap = 80;
    let addittionalGap = 280;
    let cx = rect.data('ox');
    rect.attr({ x: this.mousePositionX - mouseGap, fill: '#2c72a3' });
    moveHandler.attr({ x: this.mousePositionX - mouseGap });
    moveHandlerText.attr({ x: this.mousePositionX });

    verticalLine.remove();

    let text = this.drawnTexts.find((item) => item.rectId == rect.id);

    if (text != null) {
      text.obj.attr({ x: this.mousePositionX });
    }

    if (this.movingPath != null) this.movingPath.remove();

    let path = ['M', this.mousePositionX, this.heightOfRectangle + 10, 'V', this.state.height];
    this.movingPath = this.paper.path(path);
    this.movingPath.attr({
      'stroke-width': 3,
      'stroke-dasharray': '-',
      stroke: 'red',
    });
  }

  async onEnd(self, rect, e, moveRectangle) {
    // rect.attr('x', e.pageX)
    if (Math.abs(self.mouseDownPosition - self.mousePositionX) > 0) {
      self.props.dispatch(handleTopRightInfo({ message: 'Clusterlet reordering..', open: true }));
      // rect.attr('x', self.mousePositionX)
      // moveRectangle.attr('x', self.mousePositionX)
      self.reOrderClusterLets();
      // self.rerender()
    }
  }

  labelDragInProgress(textObj, dx, dy, e) {
    let matchingGroup = this.eventGroup.find((group) => group.label.id == textObj.id);
    matchingGroup.event.obj.attr('stroke', '#0000FF');
    this.shiftEventPosition(matchingGroup, e);
    // group = identifyGroupWithLabel()
  }

  labelDragEnd(textObj, self, e) {

    if (this.xPosOnStart == this.mosusePosY) return;

    let matchingGroup = this.eventGroup.find((group) => group.label.id == textObj.id);

    if (matchingGroup == undefined || matchingGroup.event == undefined) return;

    let parentTr = this.isInsideNestedTransaction(matchingGroup.event.obj.position.y1);

    let parentTransactionId = parentTr != undefined ? parentTr.id : self.props?.selected?._id;
    
    const verticalScroll = document.getElementById('main-content-div')?.scrollTop;
    
    const  dragEndPos = verticalScroll > 0 ? (e.clientY - 122 + verticalScroll) : e.clientY - 122;   

    let order = this.generateOrder(dragEndPos);

    let draggedEvent = self?.props?.allEvents.find((ev) => ev._id == matchingGroup?.event?.id);

    this.startXValue = matchingGroup.label.obj.attr('x');
    this.props.dispatch(handleTopRightInfo({ message: 'Event reordering..', open: true }));

    // matchingGroup.label.obj.attr('text', `${draggedEvent?.name} - Reordering..`);
    // matchingGroup.label.obj.attr('x', this.startXValue + 50);
    // let box = matchingGroup.label.obj.getBBox();
    // matchingGroup.box.obj.attr('width', box.width + 20)

    this.updateEventOrder(draggedEvent, order, parentTransactionId);

    // this.updateEventOrder(draggedEvent, order)
    // self.rerender()

    // group = identifyGroupWithLabel()
    // let newOrder = generateOrder()
    // updateEventOrder(event, newOrder)
    // refreshDataFlow()
  }

  shiftEventPosition(group, e) {
    let dargOffset = 122;
    let labelOffset = 115;
    let eventOffset = 105;
    
    const verticalScroll = document.getElementById('main-content-div')?.scrollTop;
    if (verticalScroll > 0) { // For movement when there is vertically scrolled 
      group.dragHandle.obj.attr({ y: e.clientY - dargOffset + verticalScroll });
      group.backRectangle.obj.attr({ y: e.clientY - dargOffset + verticalScroll });
      group.box.obj.attr({ y: e.clientY - dargOffset + verticalScroll });
      group.label.obj.attr({ y: e.clientY - labelOffset + verticalScroll });
      group.event.obj.attr('path', `"M${group.event.obj.position.x1},${e.clientY - eventOffset + verticalScroll}L${group.event.obj.position.x2},${e.clientY - eventOffset + verticalScroll}"`);
      group.event.obj.position.y1 = e.clientY - eventOffset + verticalScroll;
      group.event.obj.position.y2 = e.clientY - eventOffset + verticalScroll;

      if (group.onrecv !== undefined) {
        group.onrecv.obj.attr({ cy: e.clientY - eventOffset + verticalScroll});
      }

      if (group.onsend !== undefined) {
        group.onsend.obj.attr({ cy: e.clientY - eventOffset + verticalScroll});
      }
    } else { 
      group.dragHandle.obj.attr({ y: e.clientY - dargOffset });
      group.backRectangle.obj.attr({ y: e.clientY - dargOffset });
      group.box.obj.attr({ y: e.clientY - dargOffset });
      group.label.obj.attr({ y: e.clientY - labelOffset });
      group.event.obj.attr('path', `"M${group.event.obj.position.x1},${e.clientY - eventOffset}L${group.event.obj.position.x2},${e.clientY - eventOffset}"`);
      group.event.obj.position.y1 = e.clientY - eventOffset;
      group.event.obj.position.y2 = e.clientY - eventOffset;

      if (group.onrecv !== undefined) {
        group.onrecv.obj.attr({ cy: e.clientY - eventOffset });
      }

      if (group.onsend !== undefined) {
        group.onsend.obj.attr({ cy: e.clientY - eventOffset });
      }
    }
  }


  updateEventOrder(event, order, parentTransactionId) {
    // const payload = {
    // // transactionId: this.props.selected.id,
    // event: { id: event._id, order }
    // }

    this.props.dispatch(invokePostService('updateEventOrder', { eventData: { id: event._id, order: order, targetParentId: parentTransactionId } }, [this.props.selected?._id])).then((response) => {
      if (response.status) {
        this.props.dispatch(setReRender());
        this.props.dispatch(handleTopRightInfo({ message: '', open: false }));
        return;
        this.yGap = this.heightOfRectangle + 50 + this.verticalDifference;

        const orderedChildren = this.orderTransactionChildren(response.data);

        let prevChild = '';

        orderedChildren.forEach((child) => {
          /** To adjust the vertical gap between events and non-event children */

          if (['nested', 'invoked'].includes(prevChild) && ['nested', 'invoked'].includes(child.type)) this.increaseVerticalGap();

          prevChild = child.type;

          let drawnItem = false;

          if (child.type == 'event') {
            const event = this.props.events.find((e) => e._id == child.id);

            if (prevChild != 'event' && event !== null) {
              this.increaseVerticalGap();
            }

            const eventChild = this.prepareEvent(event);

            if (eventChild) {
              // this.drawSingleArrow(eventChild);
              let {
                position: { x1, y1, x2, y2 },
              } = eventChild;

              // this.drawnEvents.push({ positionY: y1, id: arrow.id })

              let matchingGroup = this.eventGroup.find((group) => group.event.id == child.id);

              // matchingGroup.label.obj.attr('text', event?.name)
              // matchingGroup.label.obj.attr('x', this.startXValue);
              // let box = matchingGroup.label.obj.getBBox();
              // matchingGroup.box.obj.attr('width', box.width + 20)
              matchingGroup.event.obj.attr('stroke', '#273e65');

              this.props.dispatch(handleTopRightInfo({ message: '', open: false }));

              this.shiftEventPosition(matchingGroup, { clientY: y1 });

              drawnItem = true;
            }
          } else if (child.type == 'nested') {
            // const nestedtransaction = this.prepareNestedTransaction(child)

            // if (nestedtransaction) {

            // const { rect, label } = this.drawSingleNestedTransaction(nestedtransaction)
            // if (rect) {
            // drawnItem = true
            // }
            // rect.attr({ 'cursor': 'pointer' })
            // rect.dblclick(function () {
            // this.props.dispatch(setDisablePan(true));
            // this.removePartialEvents();
            // this.openRightDrawer(nestedtransaction.id);
            // //self.handleEmbeddedTransactionClick(rect, nestedtransaction.id);
            // });

            // label.click(function () {
            // this.removePartialEvents();
            // this.openRightDrawer(nestedtransaction.id);
            // //self.handleEmbeddedTransactionClick(rect, nestedtransaction.id);
            // });

            // this.drawnChildTransactions.push({ rect, id: nestedtransaction.id })

            // this.dealNestedChildEvents(rect, nestedtransaction.id)
            // this.drawnChildNestedTransactions.push({ rect, id: nestedtransaction.id })

            // }
            //this.increaseVerticalGap()
          }

          if (drawnItem) {
            this.increaseVerticalGap();
          }
        });
      }
      if (response?.code == 254) {
        this.props.dispatch(setReRender());
        this.props.dispatch(handleTopRightInfo({ message: '', open: false }));
      }
    });

    //this.props.dispatch(editEventOrder(payload))
    // this.props.dispatch(onReorderClusterlet(this.props.selected.id, nodes))
  }

  reOrderClusterLets() {
    this.drawnRectangles.sort(function (c1, c2) {
      if (c1.drawnObj.attr('x') < c2.drawnObj.attr('x')) return -1;
      if (c1.drawnObj.attr('x') > c2.drawnObj.attr('x')) return 1;
      return 0;
    });

    let nodes = [];
    this.drawnRectangles.forEach((item, key) => {
      nodes.push({ id: item.id, order: key });
    });

    // this.props.dispatch(onReorderClusterlet(this.props.selected.id, nodes))
    this.props.dispatch(invokePostService('updateClusterletOrder', { clusterletArray: nodes }, [this.props.selected._id])).then((response) => {
      // if (response.status) {
      // this.props.dispatch(setReRender());
      // }
      // else {
      // this.props.dispatch(setReRender());
      // }
      this.props.dispatch(handleTopRightInfo({ message: '', open: false }));
      this.props.dispatch(handleSnackBar({ open: true, message: 'Clusterlet reordered', severity: 'success' }));
      this.props.dispatch(setReRender());
    });
  }

  componentWillUnmount() {
    this.clearPaper();
  }

  clearPaper() {
    if (this.raphaelPaper != null) this.raphaelPaper.remove();
  }

  orderTransactionChildren(transaction, eventsOnly) {
    if (eventsOnly !== undefined || eventsOnly == false) {
      let { events } = transaction;

      let children = [...events.map((e) => ({ ...e, type: 'event' }))];
      children.sort((a, b) => {
        if (a.order < b.order) return -1;
        if (a.order > b.order) return 1;
        return 0;
      });

      return children;
    } else {
      let { invokedTransactions, nestedTransactions, events, templateTransactions } = transaction;

      if (templateTransactions === undefined) {
        templateTransactions = [];
      }

      let children = [...invokedTransactions.map((i) => ({ ...i, type: 'invoked' })), ...nestedTransactions.map((n) => ({ ...n, type: 'nested' })), ...events.map((e) => ({ ...e, type: 'event' })), ...templateTransactions.map((i) => ({ ...i, type: 'template' }))];
      children.sort((a, b) => {
        if (a.order < b.order) return -1;
        if (a.order > b.order) return 1;
        return 0;
      });

      return children;
    }
  }

  orderTransactionClusterlets(transaction) {
    return transaction.clusterlets;
  }

  clusterletsDetails(clusterlets) {
    const { elements } = this.props;
    return clusterlets;
  }

  /** Prepare event to draw */
  prepareEvent(eventToDraw) {
    const event = { ...eventToDraw };

    const { events: totalEvents } = this.props;

    //event = totalEvents.find( e => e.id == event.id )

    const source = this.drawnRectangles.find((item) => item.id === event.src);
    const dest = this.drawnRectangles.find((item) => item.id === event.dst);

    if (source == undefined || dest == undefined) return false;

    const sStartinfPoint = source.drawnObj.attr('x') + this.widthOfRectangle / 2;
    const eStartingPoint = dest.drawnObj.attr('x') + this.widthOfRectangle / 2;

    event.dstStartPoint = eStartingPoint;
    event.srcStartPoint = sStartinfPoint;

    //const y = (this.heightofRectangle + 70) * (this.yGap+1);
    // const y = this.yGap
    const y = this.yDistance;

    //this.yGap++;
    event.draw = { aPath: `M${sStartinfPoint} ${y}L${eStartingPoint - 20} ${y}` };
    event.position = { x1: sStartinfPoint, y1: y, x2: eStartingPoint, y2: y };
    return event;
  }

  /** Prepare nested transaction to draw */
  prepareNestedTransaction(transaction, levels) {
    const { transction, selected, nestedTRansactions } = this.props;

    let parentTrans = this.props.allTransactions.find((tr) => tr.nestedTransactions.some((nTr) => nTr.id == transaction.id));

    let clusterletsToConsider = selected?.clusterlets || [];

    if (transaction.type == 'nested') {
      // let selectedNested = transction.find(tr => tr._id == transaction?.id)

      // if (selectedNested != undefined) {

      //     if (selectedNested.clusterlets.length > 0) {
      //         let sortedArray = []
      //         selected?.clusterlets.forEach(main => {
      //             let foundElement = selectedNested?.clusterlets.find(sec => sec.id == main.id)
      //             if (foundElement != undefined) {
      //                 sortedArray.push(main)
      //             }
      //         })

      //         clusterletsToConsider = sortedArray
      //     }

      // }
      let connectedClusterlets = selected?.clusterlets.filter((cl) => this.connectedClusterletArray.includes(cl.id));
      if (connectedClusterlets.length > 0) clusterletsToConsider = connectedClusterlets;
      else {
        clusterletsToConsider = parentTrans?.clusterlets;
      }
    }

    const { first: firstClusterlet, last: lastClusterlet } = this.firstNlastClusterlets(clusterletsToConsider);

    const source = this.drawnRectangles.find((item) => item.id === firstClusterlet.id);
    const dest = this.drawnRectangles.find((item) => item.id === lastClusterlet.id);

    if (source == undefined || dest == undefined) return false;

    //const x = source.drawnObj.attr('x') + (this.widthOfRectangle / 2) - 10
    const x = source.drawnObj.attr('x') + this.widthOfRectangle / 2 - levels * 10;
    // const y = this.yGap
    const y = this.yDistance;
    const height = this.heightOfRectangle;
    // const height = 50

    const width = dest.drawnObj.attr('x') - source.drawnObj.attr('x') + levels * 20;

    const nested = transction.find((n) => n._id == transaction.id);


    const rect = {
      box: { x, y, height, width },
      // name: { x, y: y - 7, text: nested.name + ' - ' + nested.oneof }
    };

    if (nested?.oneof != undefined && nested.oneof == true) {
      rect.name = { x, y: y - 7, text: nested.name + ' - ' + 'oneof' };
      rect.type = "oneof"
    } else if (nested?.condition !== undefined && nested.condition !== null && nested.condition !== '') {
      rect.name = { x, y: y - 7, text: nested?.name + ' - ' + 'condition(' + nested?.condition + ')' };
      rect.type = "condition"
    } else if (nested?.loop !== undefined && nested.loop !== null && nested.loop !== '') {
      rect.name = { x, y: y - 7, text: nested?.name + ' - ' + 'loop(' + nested?.loop + ')' };
      rect.type = "loop"
    } else {
      rect.name = { x, y: y - 7, text: nested?.name };
    }

    rect.id = transaction.id;


    return rect;
  }

  /** Prepare invoked transaction */
  prepareInvokedTransaction(invoked) {
    const { transction, selected } = this.props;

    let invokedTransactionData = transction.find(tr => tr._id == invoked?.id);
    const invokedTransactionClusterlets = new Set(invokedTransactionData.clusterlets.map(item => item.id)) || [];
    const commonClusterlets = selected.clusterlets.filter(item => invokedTransactionClusterlets.has(item.id));
  

    // const { first: firstClusterlet, last: lastClusterlet } = this.firstNlastClusterlets(selected.clusterlets);    
    const { first: firstClusterlet, last: lastClusterlet } = this.firstNlastClusterlets(commonClusterlets);    


    const source = this.drawnRectangles.find((item) => item.id === firstClusterlet.id);
    const dest = this.drawnRectangles.find((item) => item.id === lastClusterlet.id);

    if (source == undefined || dest == undefined) return false;

    const x = source.drawnObj.attr('x') + this.widthOfRectangle / 2 - 10;
    // const y = this.yGap
    const y = this.yDistance;
    const height = this.heightOfRectangle;
    const width = dest.drawnObj.attr('x') - source.drawnObj.attr('x') + 20;

    const trans = transction.find((n) => n._id == invoked.id);


    const rect = {
      box: { x, y, height, width },
      // name: { x, y: y - 7, text: trans.name + ' - ' + invoked.condition }
    };

    if (invoked.condition !== undefined && invoked.condition !== '') {
      rect.name = { x, y: y - 7, text: trans.name + ' - ' + 'condition(' + invoked.condition + ')' };
    } else {
      rect.name = { x, y: y - 7, text: trans.name };
    }
    rect.id = invoked.id;
    rect.uuid = invoked?.uuid

    return rect;
  }

  /** Prepare templated transaction */
  prepareTemplatedTransaction(templated) {
    const { transaction, selected } = this.props;
    const { first: firstClusterlet, last: lastClusterlet } = this.firstNlastClusterlets(selected.clusterlets);

    const source = this.drawnRectangles.find((item) => item.id === firstClusterlet.id);
    const dest = this.drawnRectangles.find((item) => item.id == lastClusterlet.id);

    if (source == undefined || dest == undefined) return false;

    const x = source.drawnObj.attr('x') + this.widthOfRectangle / 2 - 10;
    const y = this.yGap;
    const height = this.heightOfRectangle;
    const width = dest.drawnObj.attr('x') - source.drawnObj.attr('x') + 20;

    const rect = {
      box: { x, y, height, width },
      name: { x, y: y - 7, text: templated.name },
    };

    rect.id = templated.name;
    return rect;
  }

  /** Icrease this.yGap */
  increaseVerticalGap() {
    this.yGap = this.yGap + this.verticalDifference
  }

  /** Increase nested children yGap */
  increaseNestedChildrenYGap() {
    this.yGapNestedChildren = this.yGapNestedChildren + 100;
  }

  /** First & last clusterlet in the transaction */
  firstNlastClusterlets(clusterlets) {
    let sorted = clusterlets.sort((a, b) => {
      if (a.order < b.order) return -1;
      if (a.order > b.order) return 1;
      return 0;
    });

    return { first: sorted[0], last: sorted[sorted.length - 1] };
  }

  isMouseInBottomRightCorner(x, y, rectangle) {
    var rectX = rectangle.getBBox().x;
    var rectY = rectangle.getBBox().y;
    var rectWidth = rectangle.getBBox().width;
    var rectHeight = rectangle.getBBox().height;


    // Define a margin to consider the corner
    var margin = 10;

    return x >= rectX + rectWidth - margin && x <= rectX + rectWidth && y >= rectY + rectHeight - margin && y <= rectY + rectHeight;
  }

  shiftNestedPosition(group, e, allTransactions) {
    let dargOffset = 122;
    let labelOffset = 115;
    let eventOffset = 105;
  
    const movedTransaction = this.drawnChildTransactions.find(tr => tr.id == group.nested.id);
    const movedDifference = (e.clientY - 110) - movedTransaction.y;

    let verticalScroll = document.getElementById('main-content-div')?.scrollTop;

    verticalScroll = verticalScroll ? verticalScroll : 0;

    // group.dragHandle.obj.attr({ y: group.dragHandle.y + movedDifference });
    // group.backRectangle.obj.attr({ y: group.backRectangle.y + movedDifference });
    // group.box.obj.attr({ y: group.box.y + movedDifference });
    // group.label.obj.attr({ y: group.label.y + movedDifference });
    // group.nested.obj.attr({ y: group.nested.y + movedDifference });


    group.dragHandle.obj.attr({ y: e.clientY - dargOffset + verticalScroll });
    group.backRectangle.obj.attr({ y: e.clientY - dargOffset + verticalScroll });
    group.box.obj.attr({ y: e.clientY - dargOffset + verticalScroll });
    group.label.obj.attr({ y: e.clientY - labelOffset + verticalScroll });
    group.nested.obj.attr({ y: e.clientY - eventOffset + verticalScroll });

    if (group.childEvents != undefined) {
      group.childEvents.forEach((ev) => {
        let matchingGroup = this.eventGroup.find(evGp => evGp?.event?.id == ev?.id)
        matchingGroup.dragHandle.obj.attr({ y:  matchingGroup.dragHandle.y + movedDifference + verticalScroll });
        matchingGroup.backRectangle.obj.attr({ y: matchingGroup.backRectangle.y + movedDifference + verticalScroll });
        matchingGroup.box.obj.attr({ y: matchingGroup.box.y + movedDifference + verticalScroll });
        matchingGroup.label.obj.attr({ y: matchingGroup.label.y + movedDifference + verticalScroll});
        ev.path.attr('path', `"M${ev.path.position.x1},${matchingGroup.event.y + movedDifference + verticalScroll}L${ev.path.position.x2},${matchingGroup.event.y + movedDifference + verticalScroll}"`);
        
        if (matchingGroup.onrecv !== undefined) {
          matchingGroup.onrecv.obj.attr({ cy: matchingGroup.event.y + movedDifference + verticalScroll});
        }
  
        if (matchingGroup.onsend !== undefined) {
          matchingGroup.onsend.obj.attr({ cy: matchingGroup.event.y + movedDifference + verticalScroll});
        }
      });
    }

   
    if (group.childTransactions != undefined) {
      group.childTransactions.forEach((tr) => {
        let childYPos = tr.rect.attr('y');
      
        let matchingGroup = this.nestedGroup.find((group) => group.nested.id == tr.id);
        matchingGroup.dragHandle.obj.attr({ y: matchingGroup.dragHandle.y + movedDifference + verticalScroll});
        matchingGroup.backRectangle.obj.attr({ y: matchingGroup.backRectangle.y + movedDifference + verticalScroll });
        matchingGroup.box.obj.attr({ y: matchingGroup.box.y + movedDifference + verticalScroll});
        matchingGroup.label.obj.attr({ y: matchingGroup.label.y + movedDifference + verticalScroll });
        tr.rect.attr({ y: tr.y + movedDifference + verticalScroll});
      });
    }

    if (group.childInvokedTransactions) {
      group.childInvokedTransactions.forEach(tr => {
        let matchingGroup = this.invokedGroup.find((group) => group.invoked.id == tr.id);
        matchingGroup.box.obj.attr({ y: matchingGroup.box.y + movedDifference + verticalScroll});
        matchingGroup.label.obj.attr({ y: matchingGroup.label.y + movedDifference + verticalScroll });
        tr.rect.attr({ y: tr.y + movedDifference + verticalScroll});
      });
    }

  }



  onStartNestedDrag(textObj, e) {
    let matchingGroup = this.nestedGroup.find((group) => group.label.id == textObj.id);

    let allChildElements = this.getEventsAndNestedTransactionsById(matchingGroup.nested.id, this.props.allTransactions);
    let filteredChildEvents = this.drawnEvents.filter((drawnEv) => allChildElements.events.includes(drawnEv.id));
    let filteredChildTransactions = this.drawnChildTransactions.filter((drawnTr) => allChildElements.nestedTransactions.includes(drawnTr.id));
    let filteredInvokedTransactions = this.drawnChildInvokedTransactions.filter((drawnTr) => allChildElements.invokedTransactions.includes(drawnTr.id));
    matchingGroup.childEvents = filteredChildEvents;
    matchingGroup.childTransactions = filteredChildTransactions;
    matchingGroup.childInvokedTransactions = filteredInvokedTransactions;
    this.initialNestedParameters = matchingGroup.nested;
    this.mouseDownPosition = this.mousePositionX;
    this.xPosOnStart = this.mosusePosY;
    this.disablePan();
  }

  nestedDragInProgress(textObj, dx, dy, e) {
    let matchingGroup = this.nestedGroup.find((group) => group.label.id == textObj.id);
    this.shiftNestedPosition(matchingGroup, e, this.props.allTransactions);
  }

  nestedDragEnd(textObj, self, e) {
    if (this.xPosOnStart == this.mosusePosY) return;
    let matchingGroup = this.nestedGroup.find((group) => group.label.id == textObj.id);
    if (matchingGroup == undefined || matchingGroup.nested == undefined) return;
    let parentTr = this.isFullyInsideRect(matchingGroup.nested.obj.attr('y'));
    
    let parentTransactionId = parentTr != undefined ? parentTr.id : self.props?.selected?._id;

    const verticalScroll = document.getElementById('main-content-div')?.scrollTop;
    const  dragEndPos = verticalScroll > 0 ? (e.clientY - 120 + verticalScroll) : e.clientY - 120;   

    let order = this.generateOrder(dragEndPos);

    let draggedChild = self?.props?.allTransactions.find((tr) => tr._id == matchingGroup?.nested?.id);
    this.startXValue = matchingGroup.label.obj.attr('x');
    
    this.updateNestedOrder(draggedChild, order, parentTransactionId)
  }

  shiftInvokedPosition(group, e) {
    let dargOffset = 122;
    let labelOffset = 115;
    let eventOffset = 105;
    let verticalScroll = document.getElementById('main-content-div')?.scrollTop;

    verticalScroll = verticalScroll ? verticalScroll : 0;

    group.dragHandle.obj.attr({ y: e.clientY - dargOffset + verticalScroll });
    group.backRectangle.obj.attr({ y: e.clientY - dargOffset + verticalScroll });
    group.box.obj.attr({ y: e.clientY - dargOffset + verticalScroll });
    group.label.obj.attr({ y: e.clientY - labelOffset + verticalScroll });
    group.invoked.obj.attr({ y: e.clientY - eventOffset + verticalScroll });

  }

  onStartInvokedDrag(textObj, e) {
    let matchingGroup = this.invokedGroup.find((group) => group.label.id == textObj.id);
    this.initialNestedParameters = matchingGroup.invoked;
    this.mouseDownPosition = this.mousePositionX;
    this.xPosOnStart = this.mosusePosY;
  }

  invokedDragInProgress(textObj, dx, dy, e) {
    let matchingGroup = this.invokedGroup.find((group) => group.label.id == textObj.id);
    this.shiftInvokedPosition(matchingGroup, e);
  }

  invokedDragEnd(textObj, self, e) {
    if (this.xPosOnStart == this.mosusePosY) return;
    let matchingGroup = this.invokedGroup.find((group) => group.label.id == textObj.id);
    if (matchingGroup == undefined || matchingGroup.invoked == undefined) return;
   
    let parentTr = this.isFullyInsideRect(matchingGroup.invoked.obj.attr('y'));
    
    let parentTransactionAfterDrag = parentTr != undefined ? parentTr.id : self.props?.selected?._id;

    const verticalScroll = document.getElementById('main-content-div')?.scrollTop;
    const  dragEndPos = verticalScroll > 0 ? (e.clientY - 120 + verticalScroll) : e.clientY - 120;   

    let order = this.generateOrder(dragEndPos);

    this.startXValue = matchingGroup.label.obj.attr('x');

    const childTransactionsInsideSelectedTransaction = this.getNestedTransactionsOfSelectedTransaction(this.props.allTransactions, this.props.selected);

    const parentTransactionBeforeDrag = [this.props.selected, ...childTransactionsInsideSelectedTransaction].find(transaction=> {
     return transaction.invokedTransactions.some(item => item.id == matchingGroup.invoked.id);
    });
    if (parentTransactionBeforeDrag) {
      this.updateInvokedOrder(matchingGroup.invoked.id, parentTransactionBeforeDrag._id, parentTransactionAfterDrag, order)
    }
    
  }

  updateInvokedOrder(invokedTransactionId, parentTransactionBeforeDrag, parentTransactionAfterDrag, order) {
    this.props.dispatch(invokePostService('updateInvokedOrder', { invokedTransactionId, parentTransactionBeforeDrag, parentTransactionAfterDrag, order }, [this.props.selected?._id])).then((response) => {
      if (response.status) {
        this.props.dispatch(setReRender());
        this.props.dispatch(handleTopRightInfo({ message: '', open: false }));
      }
      if (response?.code == 254) {
        this.props.dispatch(setReRender());
        this.props.dispatch(handleTopRightInfo({ message: '', open: false }));
      }
    });
  }
  

  updateNestedOrder(nestedTransaction, order, parentTransactionId) {
    this.props.dispatch(invokePostService('updateNestedOrder', { nestedData: { id: nestedTransaction._id, order: order, targetParentId: parentTransactionId } }, [this.props.selected?._id])).then((response) => {
      console.log("respons-------->", response)
      if (response.status) {
        this.props.dispatch(setReRender());
        this.props.dispatch(handleTopRightInfo({ message: '', open: false }));
      }
      if (response?.code == 254) {
        this.props.dispatch(setReRender());
        this.props.dispatch(handleTopRightInfo({ message: '', open: false }));
      }
    });

    //this.props.dispatch(editEventOrder(payload))
    // this.props.dispatch(onReorderClusterlet(this.props.selected.id, nodes))
  }

  getEventsAndNestedTransactionsById(id, data) {
    const result = {
      events: [],
      nestedTransactions: [],
      invokedTransactions: []
    };

    function findItemById(id, arr) {
      return arr.find((item) => item._id == id);
    }

    function processItem(item) {
      if (!item) return;

      if (item.events && item.events.length > 0) {
        const idArray = item.events.map((item) => item.id);
        result.events.push(...idArray);
      }

      if (item.nestedTransactions && item.nestedTransactions.length > 0) {
        item.nestedTransactions.forEach((nestedId) => {
          const nestedItem = findItemById(nestedId.id, data);
          result.nestedTransactions.push(nestedItem?._id);

          // Recursively process nested transactions
          processItem(nestedItem);
        });
      }

      if (item.invokedTransactions && item.invokedTransactions.length > 0) {
        item.invokedTransactions.forEach((invokedId) => {
          const invokedItem = findItemById(invokedId.id, data);
          result.invokedTransactions.push(invokedItem?._id);

          // Recursively process nested transactions
          processItem(invokedItem);
        });
      }
    }

    const initialItem = findItemById(id, data);

    if (initialItem) {
      processItem(initialItem);
    }

    return result;
  }

  /** Draw single nested transaction */
  drawSingleNestedTransaction({ box, name, id, type }, prevYGap) {
    // const paperElement = document.getElementById("papercanvas");

    const { x: boxX, y: boxY, width, height } = box;
    const { x: textX, y: textY, text } = name;
    const self = this;

    const rect = this.paper.rect(boxX, boxY, width, height);

    this.lastDrawnY = boxY;
    // rect.attr(nestedTransactionConfig);
    if (type === "oneof") {
      rect.attr(nestedOneofTransactionConfig);
    } else if (type === "condition") {
      rect.attr(nestedConditionalTransactionConfig);
    } else if (type === "loop") {
      rect.attr(nestedLoopTransactionConfig);
    } else {
      rect.attr(nestedTransactionConfig);
    }

    rect.hover(
      function (event) {
        this.data('glow', this.glow(glowSettings));
      },
      function () {
        this.data('glow').remove();
      },
    );

    const label = this.paper.text(boxX, textY, text).attr(translabelAttributes);
    let labelBox = label.getBBox();
    let labelBoxRect = this.paper.rect(labelBox.x - 10, labelBox.y, labelBox.width + 20, labelBox.height).attr(nestedTransactionLabelConfig);

    let backGroundRect = self.paper.rect(labelBox.x - 30, labelBox.y, 20, labelBox.height).attr(backRect);
    let dragHandle = self.paper.image(`${process.env.PUBLIC_URL}/dragImage1.png`, labelBox.x - 30, labelBox.y, 20, labelBox.height).attr(dragHandler);

    const elementObj = {
      nested: { obj: rect, id: id, y: rect.attrs.y },
      label: { obj: label, id: label.id, y: label.attrs.y },
      box: { obj: labelBoxRect, id: labelBoxRect.id, y: labelBoxRect.attrs.y },
      dragHandle: { obj: dragHandle, id: dragHandle.id, y: labelBoxRect.attrs.y },
      backRectangle: { obj: backGroundRect, id: backGroundRect.id, y: backGroundRect.attrs.y },
      gap: prevYGap,
    };

    // let drawnEventsInChildElements = self.drawnEvents.filter()

    labelBoxRect.hover(function () {
      this.attr('title', 'Nested transaction');
    });

    label.toFront();
    this.nestedGroup.push(elementObj);

    dragHandle.drag(
      (dx, dy, mx, my, e) => {
        self.nestedDragInProgress(label, dx, dy, e);
      },
      (e) => {
        this.onStartNestedDrag(label, e);
      },
      (e) => {
        self.nestedDragEnd(label, self, e);
      },
    );
    return { rect, label };
  }

  /** Draw single invoked transaction */
  drawSingleInvokedTransaction({ box, name, id }) {
    const { x: boxX, y: boxY, width, height } = box;
    const { x: textX, y: textY, text } = name;

    const rect = this.paper.rect(boxX, boxY, width, height);
    this.lastDrawnY = boxY;
    rect.attr(invokedTransactionConfig);
    rect.hover(
      function () {
        this.data('glow', this.glow(glowSettings));
      },
      function () {
        this.data('glow').remove();
      },
    );

    const label = this.paper.text(boxX, textY, text).attr(translabelAttributes);
    let labelBox = label.getBBox();
    let labelBoxRect = this.paper.rect(labelBox.x - 10, labelBox.y, labelBox.width + 20, labelBox.height).attr(nestedTransactionLabelConfig);

    labelBoxRect.hover(function () {
      this.attr('title', 'Invoked transaction');
    });

    label.toFront();
    const invokedDragHandler = JSON.parse(JSON.stringify(dragHandler));
    invokedDragHandler.title = "Click to drag the invoked transaction";
    let backGroundRect = this.paper.rect(labelBox.x - 30, labelBox.y, 20, labelBox.height).attr(backRect);
    let dragHandle = this.paper.image(`${process.env.PUBLIC_URL}/dragImage1.png`, labelBox.x - 30, labelBox.y, 20, labelBox.height).attr(invokedDragHandler);

    const elementObj = {
      invoked: { obj: rect, id: id, y: rect.attrs.y },
      label: { obj: label, id: label.id, y: label.attrs.y },
      box: { obj: labelBoxRect, id: labelBoxRect.id, y: labelBoxRect.attrs.y },
      dragHandle: { obj: dragHandle, id: dragHandle.id, y: labelBoxRect.attrs.y },
      backRectangle: { obj: backGroundRect, id: backGroundRect.id, y: backGroundRect.attrs.y },
    };

    this.invokedGroup.push(elementObj)

    dragHandle.drag(
      (dx, dy, mx, my, e) => {
        this.invokedDragInProgress(label, dx, dy, e);
      },
      (e) => {
        this.onStartInvokedDrag(label, e);
      },
      (e) => {
        this.invokedDragEnd(label, this, e);
      },
    );

    return { rect, label };
  }

  /** Draw single templated transaction */
  drawSingleTemplatedTransaction({ box, name }) {
    const { x: boxX, y: boxY, width, height } = box;
    const { x: textX, y: textY, text } = name;
    const rect = this.paper.rect(boxX, boxY, width, height);
    rect.attr(templatedTransactionConfig);
    const label = this.paper.text(textX, textY, text).attr(labelAttributes);
    let labelBox = label.getBBox();
    let labelBoxRect = this.paper.rect(labelBox.x - 10, labelBox.y, labelBox.width + 20, labelBox.height).attr(nestedTransactionLabelConfig);
    labelBoxRect.hover(function () {
      this.attr('title', 'Invoked transaction');
    });

    label.toFront();

    return { rect, label };
  }

  /** Draw nested child events */
  dealNestedChildEvents(rect, transactionId) {
    const { nestedTRansactions, allEvents } = this.props;
    // console.log('props----->', { nestedTRansactions, allEvents });
    const transaction = nestedTRansactions.find((n) => n._id == transactionId);

    let tmpDifference = this.verticalDifference + 20;
    this.verticalDifference = this.yGapNestedChildren;
    this.yGap = this.yGap + this.yGapNestedChildren;

    let tEvents = transaction?.events !== undefined ? transaction.events : [];

    // console.log('teevents------>', tEvents);

    tEvents.sort((a, b) => {
      if (a.order < b.order) return -1;
      if (a.order > b.order) return 1;
      return 0;
    });

    tEvents.forEach((ev) => {
      const event = allEvents.find((e) => e._id == ev.id);
      const eventChild = this.prepareEvent(event);

      // console.log('eventChild----->', eventChild);

      if (eventChild) {
        this.increaseVerticalGap();
        this.drawSingleArrow(eventChild);
        // this.increaseVerticalGap()
      }
    });

    /** Adjust the height of parent nested transaction as child events drawn */
    if (tEvents.length > 0) {
      // --rect.attr('height', (transaction.events.length * this.yGapNestedChildren) + this.yGapNestedChildren)
    }

    this.verticalDifference = tmpDifference - 10;
  }

  getNestedLevelsById(array, targetId) {
    function findDepth(id) {
      for (const obj of array) {
        if (obj._id == id) {
          if (obj.nestedTransactions.length === 0) {
            return 1; // The current object has no children (base case)
          } else {
            let maxDepth = 0;
            for (const child of obj.nestedTransactions) {
              const childDepth = findDepth(child.id);
              maxDepth = Math.max(maxDepth, childDepth);
            }
            return maxDepth + 1; // Add 1 for the current object level
          }
        }
      }
      return 0; // ID not found in the array
    }

    return findDepth(targetId);
  }

  // To find the nested transactions of a given transaction/child transaction
  getNestedTransactionsOfSelectedTransaction(transactions, targetTransaction) {
    let nestedChildTransactions = [];
  
    function findDepth(transaction) {
      for (const child of transaction.nestedTransactions) {
        const childTransaction = transactions.find(t => t._id === child.id);
        if (childTransaction) {
          nestedChildTransactions.push(childTransaction);
          findDepth(childTransaction);
        }
      }
    }
  
    findDepth(targetTransaction);
    return nestedChildTransactions;
  }


  getNestedEvents(array, events, targetId) {
    // console.log('array, evenst------>', array, events);

    let eventsArray = [];
    let clusterletArray = [];

    function findDepth(id) {
      for (const obj of array) {
        if (obj._id == id) {
          if (obj.events.length > 0) {
            // console.log('attay length------.', obj.events);
            obj.events.forEach((ev) => {
              let childEvent = events.find((cEvent) => cEvent._id == ev.id);
              if (!clusterletArray.includes(childEvent?.src)) clusterletArray.push(childEvent?.src);
              if (!clusterletArray.includes(childEvent?.dst)) clusterletArray.push(childEvent?.dst);
            });
          }
          if (obj.nestedTransactions.length === 0) {
            return clusterletArray;
          } else {
            for (const child of obj.nestedTransactions) {
              findDepth(child.id);
            }
          }
        }
      }
      return clusterletArray;
    }

    return findDepth(targetId);
  }

  getEventConnectedClusterlets(nestedId) {
    const nestedTransaction = this.props.allTransactions.find((tr) => tr._id == nestedId);
    let clusterletArray = [];

    nestedTransaction.events.forEach((ev) => {
      let childEvent = this.props.allEvents.find((cEvent) => cEvent._id == ev.id);
      if (!clusterletArray.includes(childEvent?.src)) clusterletArray.push(childEvent?.src);
      if (!clusterletArray.includes(childEvent?.dst)) clusterletArray.push(childEvent?.dst);
    });


    // let filteredClusterlet = this.props.selected.clusterlets.filter(cl => clusterletArray.includes(cl.id))
    return clusterletArray;
  }

  dealNestedChildTrans(transaction, events, self, parentRect, prevYGap = 0) {
    let children = this.orderTransactionChildren(transaction);
    let lastDrawnY = '';

    children.forEach((child) => {
      /** To adjust the vertical gap between events and non-event children */
      if (['nested', 'invoked'].includes(this.prevChild) && ['nested', 'invoked'].includes(child.type)) {
        //this.increaseVerticalGap()
      }

      let drawnItem = false;
      if (child.type == 'event') {

        const event = this.props.allEvents.find((e) => e._id == child.id);

        // console.log('prevChild', this.prevChild);
        if (this.prevChild != 'event' && event !== null) {
          // this.increaseVerticalGap()
          // this.yDistance += 40

          // console.log('yGap increased2', this.yGap, event?.name);
        }

        const eventChild = this.prepareEvent(event);
        this.prevChild = child.type;
        if (eventChild) {
          this.drawSingleArrow(eventChild);
          // console.log('yGap increased event', this.yGap, event?.name);
          // this.increaseVerticalGap()
          this.yDistance += 40;
          drawnItem = true;
          // console.log('drawn/ 3rd event');
        }
      } else if (child.type == 'nested') {
        const nestedLevels = this.getNestedLevelsById(this.props.allTransactions, child.id);

        let initialGap = 0;

        // Get the clusterlets connected by child events of the neted transaction
        const connectedClusterlets = this.getNestedEvents(this.props.allTransactions, this.props.allEvents, child.id);
        // console.log('connectedClusterlets------->', connectedClusterlets);
        this.connectedClusterletArray = connectedClusterlets;

        this.yDistance += 40;

        const nestedtransaction = this.prepareNestedTransaction(child, nestedLevels, prevYGap);
        
        if (nestedtransaction) {
          const { rect, label } = this.drawSingleNestedTransaction(nestedtransaction, prevYGap);
          if (rect) {
            drawnItem = true;
          }

          rect.attr({ cursor: 'pointer' });
          rect.dblclick(function () {
            self.props.dispatch(setDisablePan(true));
            self.removePartialEvents();
            self.openRightDrawer(nestedtransaction.id);
            //self.handleEmbeddedTransactionClick(rect, nestedtransaction.id);
          });

          label.click(function () {
            self.removePartialEvents();
            self.openRightDrawer(nestedtransaction.id);
            //self.handleEmbeddedTransactionClick(rect, nestedtransaction.id);
          });

          this.drawnChildTransactions.push({ y: rect.attrs.y, id: nestedtransaction.id, height: rect.attrs.height, rect })
          this.drawnChildNestedTransactions.push({ rect, id: nestedtransaction.id });

          let nestedTransactionChildren = this.props.allTransactions.find((tr) => tr._id == nestedtransaction.id);
          this.prevChild = child.type;

          if (nestedTransactionChildren != undefined) {
            this.yDistance += 40;
            let heightOfRect = this.yDistance;
            this.dealNestedChildTrans(nestedTransactionChildren, events, self, rect, this.yDistance - 120);
            
            // console.log('yGap final', this.yDistance, rect, nestedTransactionChildren);
            rect.attr('height', this.yDistance - heightOfRect + 40);
            this.yDistance += 50;
            // rect.attr('height', this.yGap - 130)

            // rect.attr('height', (nestedTransactionChildren.events.length * this.verticalDifference) + 70)
            // this.increaseVerticalGap()
            // console.log('drawn/ nested transaction');
          }
          // this.yDistance += 50
        }
      } else if (child.type == 'invoked') {
        // console.log({ childInsideInvoked: child });

        const invokedChild = this.prepareInvokedTransaction(child);
        this.yDistance += 40;
        console.log("invokedChild---", invokedChild)
        if (invokedChild) {
          const { rect, label } = this.drawSingleInvokedTransaction(invokedChild);
          if (rect) {
            drawnItem = true;
          }

          rect.attr({ cursor: 'pointer' });
          rect.dblclick(function () {
            self.props.dispatch(setDisablePan(true));
            self.removePartialEvents();
            self.openRightDrawer(invokedChild.id);
            //self.handleEmbeddedTransactionClick(rect, invokedChild.id);
          });

          label.click(function () {
            self.removePartialEvents();
            self.openRightDrawer(invokedChild.id, invokedChild.uuid);
            //self.handleEmbeddedTransactionClick(rect, invokedChild.id);
          });
          this.yDistance = this.yDistance + this.heightOfRectangle + 20;
          this.drawnChildInvokedTransactions.push({ rect, id: invokedChild.id, y: rect.attrs.y });
          parentRect?.attr("width", rect.attrs.width + 20)
          parentRect?.attr("x", rect.attrs.x - 10)
          if(parentRect){
            let labelRect = parentRect.next;
            let dragRect = labelRect.next;
            let dragImage = dragRect.next;
            let labelText = dragImage.next;

            labelRect.attr("x", rect.attrs.x - 10 + dragRect.attrs.width)
            dragRect.attr("x", rect.attrs.x - 10)
            dragImage.attr("x", rect.attrs.x - 10)
            labelText.attr("x", rect.attrs.x - 10 + 32)
            
          }
        }
      } else if (child.type == 'template') {
        const { rect, label, templatedChild } = this.drawTemplateTransaction(child);
        if (rect) {
          drawnItem = true;
        }

        if (templatedChild) {
          rect.attr({ cursor: 'pointer' });
          rect.dblclick(function () {
            self.props.dispatch(setDisablePan(true));
            // self.removePartialEvents();
            self.openRightDrawer(templatedChild.id);
            //self.handleEmbeddedTransactionClick(rect, invokedChild.id);
          });

          label.click(function () {
            // self.removePartialEvents();
            self.openRightDrawer(templatedChild.id);
            //self.handleEmbeddedTransactionClick(rect, invokedChild.id);
          });
        }
      }
    });

    if (parentRect !== undefined) {
      // parentRect.attr('height', this.yGap + 20)
    }
  }

  /** Open right drawer for nodes */
  openRightDrawer(id, uuid) {
    //Combined clusterlets
    let participants = [...this.props.eventViewProps.allClusterlets, ...this.props.eventViewProps.templatedClusterlets];

    let clickedNode = participants.find((node) => node._id == id);
    // console.log('clickedNode------>', clickedNode);

    if (clickedNode === undefined) clickedNode = this.props.eventViewProps.allTransactions.find((tr) => tr._id == id);

    if (clickedNode === undefined) {
      if (this.props.selected.templateTransactions !== undefined) {
        clickedNode = this.props.selected.templateTransactions.find((templateTran) => templateTran.name === id);
      }
    }

    // console.log('clicked Node----->', clickedNode);

    if (clickedNode === undefined) return false;

    let type = null;

    if (clickedNode.type == 1) type = 'external_function';
    if (clickedNode.type == 2) type = 'clusterlet';
    if (clickedNode.type == 3) type = 'analytics';
    if (clickedNode.type == 4) type = 'sensor';
    if (clickedNode.type == 7) type = 'transaction';
    if (clickedNode.type == 9) type = 'nested_transaction';
    if (clickedNode.type == 19) type = 'transaction';
    if (clickedNode.type == 23) type = 'templated_clusterlet';
    if (clickedNode.type == 24) type = 'templated_transaction';

    // this.props.dispatch(setFocusElement({ id: id, item: clickedNode, type }))
    this.props.dispatch(
      setFocusElement({
        id: clickedNode?._id,
        uuid: uuid,
        type: type,
        name: clickedNode?.name,
        protocol: clickedNode?.attributes ? clickedNode?.attributes?.type : '',
        icon: clickedNode?.icon ? clickedNode?.icon : '',
        desc: clickedNode?.attributes ? clickedNode?.attributes?.desc : '',
        templateId: clickedNode?.templateId ? clickedNode?.templateId : '',
      }),
    );
    if (this.props.rightDrawerStatus === false) {
      this.props.dispatch(toggleRightDrawer());
    }
  }

  getNodeType = (type) => {
    if (type == 1) return 'Delegate';
    else if (type == 2) return 'Digital Twin';
    else if (type == 3) return process.env.REACT_APP_ANALYTICS;
    else if (type == 4) return 'Sensor';
    else if (type == 23) return 'Template';
  };

  /** Initiate the whole drawing process */
  initiateDrawing() {
    this.enablePan();
    let transactionClusterlets = [];

    if (this.renderInProgress == true) return false;

    this.drawnRectangles = [];

    this.renderInProgress = true;
    const self = this;
    const { clusterlets = [], selected, delegates = [], sensors = [], transction, events, nestedTRansactions } = this.props;

    this.selectedTransaction = selected; //for a class wide usage
    this.transctionsList = transction; //for a class wide usage

    this.props.dispatch(setSelectedTransactionId(this.props.selected.id ? this.props.selected.id : transction[0].id));

    //combining user defined and template clusterlets
    let transactionParticipants = [...this.props.elements, ...this.props.templatedClusterlets];

    selected.clusterlets.forEach((clusterlet, index) => {
      transactionParticipants.forEach((element, index) => {
        if (clusterlet.id === element._id) {
          transactionClusterlets.push({ name: element.name, id: element._id, type: element.type });
        }
      });
    });

    const currentNodes = this.props.elements //elements
      .filter((i) => i.type === 2 || i.type === 1 || i.type === 3 || i.type === 4)
      .map((i) => i.name);

    const { width, height } = this.state;
    // const normalColor = "#3598DC"
    const normalColor = '#273e65'; //node color changed
    const templateNodeColor = '#fb7885';

    let offsetDivider = 8;
    let windowWidth = window.innerWidth;

    const margin = 10 + 64 + 171;
    const optimalOffset = 180; //230;
    const minimumOffset = 10; //margin;
    const paperMargin = 40;

    //let offset1 = (width - (2 * paperMargin) - this.widthOfRectangle - (2 * margin)) / (transactionClusterlets.length - 1);
    let offset1 = (width - 2 * paperMargin - margin - transactionClusterlets.length * this.widthOfRectangle) / (transactionClusterlets.length - 1);

    //offset1 = offset1 - this.widthOfRectangle;

    offset1 = Math.round(offset1 / 10) * 10;

    if (offset1 < minimumOffset) offset1 = minimumOffset;
    if (offset1 > optimalOffset) offset1 = optimalOffset;

    const options = {
      dimensions: {
        width,
        height,
        offset: offset1, // width / offsetDivider,
        widthOfRectangle: this.widthOfRectangle,
        heightofRectangle: this.heightOfRectangle, //100
      },
      boxes: { clusterlets, delegates },
    };

    this.clearPaper();

    let canvasEl = document.getElementById('papercanvas');
    const paper = Raphael(canvasEl, '100%', '100%');
    //paper.setViewBox(0, 0, paperWidth, 700, true); //setViewBox(x, y, w, h, fit)
    this.raphaelPaper = paper;
    this.paper = paper;

    const [board, positions] = generateBoard(options, transactionClusterlets, this.paper.width);

    /** Draw transaction nodes */
    for (let index = 0; index < board.length; index++) {
      const { rect, text, path, startingPoint, name, uuid, type } = board[index];

      const rectangle = paper.rect(...rect);
      rectangle.data('id', uuid);

      rectangle.attr({
        cursor: 'pointer',
        fill: '#0ff000',
      });

      rectangle.node.setAttribute('data-ui-tour-id', 'df-node');

      const moveRectangle = paper.rect(rectangle.attr('x'), rectangle.attr('y') + 50, this.widthOfRectangle, 20, 10);
      moveRectangle.attr({ cursor: 'all-scroll', fill: '#6a7795', title: 'Click and drag to change position' });
      // moveRectangle.attr({ 'cursor': 'all-scroll', 'fill': '#3f4e5c', 'title': 'Click and drag to change position' }); // move rectangle text color changed
      
      const moveRectangleText = paper.text(rectangle.attr('x') + this.widthOfRectangle / 2, rectangle.attr('y') + 60, self.getNodeType(type));
      moveRectangleText.attr({ fill: '#fff' });

      this.drawnRectangles.push({ name: name, id: uuid, drawnObj: rectangle });

      rectangle.click(function () {
        if (self.props.codeEditStatus) {
          // For alert to save when handler code is editing
          self.props.dispatch(setIsDocumentClicked());
          return;
        }
        self.props.dispatch(setTabOnFocus(0));
        self.openRightDrawer(this.data('id'));
      });

      var circle = paper.circle(0, 0, 6);
      circle.attr({ fill: 'red' });
      circle.hide();
      var hovering = false;

      /** Vertical line */
      const verticalLine = paper.path(path);
      var bbox = verticalLine.getBBox();
      var xPosition = bbox.x;
      this.verticalLineCordinates.push(bbox);
      verticalLine.attr({ 'stroke-width': 3, stroke: '#555555' });

      this.drawnVerticalLines.push({ rect: rectangle, line: verticalLine });


      //Drag
      moveRectangle.drag(
        (dx, dy, mx, my, e) => {
          console.log("on move ------------------------------")
          self.onMove(moveRectangle, moveRectangleText, rectangle, verticalLine, dx, dy, e);
        },
        (e) => {
          console.log("on start ------------------------------")
          
          this.onStart(e);
        },
        (e) => {
          console.log("on drag end ------------------------------")
          
          self.onEnd(self, rectangle, e, moveRectangle);
        },
      );

      if (board[index].type == 23) {
        rectangle.attr({ fill: templateNodeColor, title: 'Template clusterlet - READONLY' }); //.hover(hoverIn, hoverOut)
      } else {
        rectangle.attr({ fill: normalColor, title: 'Click to edit the configuraton' });
      }

      const label = paper.text(...text);
      this.drawnTexts.push({ rectId: rectangle.id, obj: label });
      this?.startingPoints.push({ id: uuid, name, startPoint: startingPoint });
      label.data('id', uuid);

      label.attr({
        cursor: 'pointer',
        fill: '#fff', // new line added
      });

      label.click(function () {
        self.props.dispatch(setTabOnFocus(0));
        self.openRightDrawer(this.data('id'));
      });
    }

    this.dealNestedChildTrans(selected, events, self);

    //this.drawVerticalLines();
    this.updateVerticalLines();

    const paperHeight = this.newPaperHeight();
    this.paper.setSize('100%', paperHeight);

    self.moveListener = this.paper.canvas.addEventListener('mousemove', function (event) {
      var mouseX = event.offsetX;
      var mouseY = event.offsetY;
      self.mousePositionX = mouseX;
      self.mosusePosY = mouseY;


      if (self.plotingMarker !== null) {
        self.plotingMarker.remove();
      }
      if (self.props.eventViewProps?.transactionState?.drawEvent) {
        self.verticalLineCordinates.forEach((cor, index) => {
          if (Math.abs(mouseX - cor.x) <= 5 && self.eventPlotPoints?.startPoint == null) {
            self.plotingMarker = paper.circle(0, 0, 10);
            self.plotingMarker.attr({ fill: '#ffdf19' });
            self.plotingMarker.attr({ cursor: 'pointer' });
            self.plotingMarker.toFront();
            self.plotingMarker.hover(function () {
              this.attr('title', self.eventPlotPoints?.startPoint != null ? 'Click to mark the end point' : 'Click to mark the starting point');
            });
            self.plotingMarker.attr({ cx: cor.x + cor.width / 2, cy: mouseY });
          }
          if (Math.abs(mouseX - cor.x) <= 5 && self.eventPlotPoints?.startPoint != null && mouseY < self.nearestValues?.nearestGreater?.positionY && mouseY > self.nearestValues?.nearestSmaller?.positionY && Math.abs(mouseX - self.eventPlotPoints?.startPoint?.downPosition.x) > 6) {
            self.plotingMarker = paper.circle(0, 0, 10);
            self.plotingMarker.attr({ fill: '#ffdf19' });
            self.plotingMarker.attr({ cursor: 'pointer' });
            self.plotingMarker.toFront();
            self.plotingMarker.hover(function () {
              this.attr('title', self.eventPlotPoints?.startPoint != null ? 'Click to mark the end point' : 'Click to mark the starting point');
            });
            self.plotingMarker.attr({ cx: cor.x + cor.width / 2, cy: mouseY });
          }
        });
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.keyCode === 27) {
        self.enablePan();
      }
    });

    return;
  }

  drawVerticalLines() {
    this.drawnRectangles.forEach((rect) => {
      const x = rect.drawnObj.attr('x') + this.widthOfRectangle / 2;
      const y2 = this.lastDrawnY + 400 > window.screen.height - 230 ? this.lastDrawnY + 400 : window.screen.height - 230;
      const aPath = `M${x} ${rect.drawnObj.attr('y') + this.heightOfRectangle}L${x} ${y2}`;
      const verticalLine = this.paper.path(aPath);
      verticalLine.attr({ 'stroke-width': 3, stroke: '#555555' });
    });
  }

  updateVerticalLines() {
    this.drawnVerticalLines.forEach((item) => {
      const x = item.rect.attr('x') + this.widthOfRectangle / 2;
      const y2 = this.newPaperHeight();
      const path = `M${x} ${item.rect.attr('y') + this.heightOfRectangle}L${x} ${y2}`;
      item.line.attr('path', path);
    });
  }

  drawTemplateTransaction = (templated) => {
    const templatedChild = this.prepareTemplatedTransaction(templated);

    if (!templatedChild) return false;

    const { rect, label } = this.drawSingleTemplatedTransaction(templatedChild);
    const res = this.drawTemplatedTransactionEvents(templated, rect);
    this.drawnTemplatedTransactions.push({ rect, name: templated.name });
    return { rect, label, templatedChild };
  };

  drawTemplatedTransactionEvents = (templated, parentTransactionBox) => {
    const templateClusterlet = this.props.eventViewProps.templatedClusterlets.find((t) => t.id == templated.templateId);
    const templateTransactionChildren = templateClusterlet.metajson.callflowdefs[templated.name].children;
    const connectors = templateClusterlet.metajson.connectors;
    const connected = templateClusterlet.connected;

    const eventsToDraw = [];
    templateTransactionChildren.forEach((child) => {
      if (child.type == 'sendmsg') {
        for (let key of Object.keys(connectors)) {
          if (connectors[key].from.includes(child.name)) {
            eventsToDraw.push({
              src: connected[key],
              dst: templated.templateId,
              id: child.name,
              name: child.name,
              attributes: {
                onsend: true,
                onrecv: false,
              },
              message: null,
              category: 'template',
            });

            break;
          }
          if (connectors[key].to.includes(child.name)) {
            eventsToDraw.push({
              dst: connected[key],
              src: templated.templateId,
              id: child.name,
              name: child.name,
              attributes: {
                onsend: false,
                onrecv: true,
              },
              message: null,
              category: 'template',
            });
            break;
          }
        }
      }
    });

    eventsToDraw.forEach((event) => {
      this.yGap = this.yGap + 30;
      const eventChild = this.prepareEvent(event);
      if (eventChild) this.drawSingleArrow(eventChild);
    });

    if (eventsToDraw.length > 0) {
      parentTransactionBox.attr('height', eventsToDraw.length * this.yGapNestedChildren + this.yGapNestedChildren);
    }
  };

  getOffet = (element) => {
    const rect = element.getBoundingClientRect();
    const offset = { top: rect.top + window.scrollY, left: rect.left + window.scrollX };
    return offset;
  };

  findTheCloset = (goal) => {
    return this.startingPoints.reduce(function (prev, curr) {
      const crrPoint = curr.startPoint || curr;
      const prevPoint = prev.startPoint || prev;
      const condition = Math.abs(crrPoint - goal) < Math.abs(prevPoint - goal);
      return condition ? crrPoint : prevPoint;
    });
  };

  findTheClosest = (goal) => {
    return this.drawnRectangles.reduce((prev, curr) => {
      const crrPoint = curr.drawnObject.attr('x');
      if (Math.abs(crrPoint - goal) - prev) return crrPoint;
      else return prev;
    }, 0);
  };

  findTheClusterlet = (startPoint) => {
    return this.startingPoints.find((i) => i.startPoint === startPoint);
  };

  findClusterletsOfNestedTransaction(targetRect) {
    var targetX = targetRect.attr('x');
    var targetWidth = targetRect.attr('width');
    var targetStart = targetX;
    var targetEnd = targetX + targetWidth;
    let rectangleWidth = this.widthOfRectangle;

    // console.log('rects drawn------>', this.drawnRectangles, targetRect, this.widthOfRectangle);

    var filteredRectangles = this.drawnRectangles.filter(function (rect) {
      // if (rect === targetRect) {
      // return false; // Exclude the target rectangle itself
      // }
      var rectX = rect.drawnObj.attr('x') + rectangleWidth / 2;
      var rectWidth = rect.drawnObj.attr('width');

      // Check if the rectangle falls between the width of the target rectangle
      return rectX >= targetStart && rectX <= targetEnd;
    });

    return filteredRectangles;
  }

  clusterletsWithOrder(filteredClusterlets) {
    const filteredArray = this.props.selected.clusterlets.filter((element) => filteredClusterlets.some((filterElement) => filterElement.id == element.id));

    return filteredArray;
  }

  getEventsWithMatchingClusterlets(events, clusterlets) {
    return events.filter((event) => {
      const srcExists = clusterlets.some((clusterlet) => clusterlet.id === event.src || clusterlet.id === event.dst);
      // const dstExists = clusterlets.some(clusterlet => clusterlet.id === event.dst);
      // return srcExists && dstExists;
      return srcExists;
    });
  }

  isRectInside(rectA, rectB) {
    const rectAX = rectA.rect.attr('x');
    const rectAY = rectA.rect.attr('y');
    const rectAW = rectA.rect.attr('width');
    const rectAH = rectA.rect.attr('height');

    const rectBX = rectB.attr('x');
    const rectBY = rectB.attr('y');
    const rectBW = rectB.attr('width');
    const rectBH = rectB.attr('height');

    return rectAX >= rectBX && rectAY >= rectBY && rectAX + rectAW <= rectBX + rectBW && rectAY + rectAH <= rectBY + rectBH;
  }

  findNestedTransactions(obj, id) {
    console.log({obj, id})
    if (obj?._id && obj?._id == id) {
      return obj.nestedTransactions;
    }

    for (const key in obj) {
      if (typeof obj[key] === 'object') {
        const result = this.findNestedTransactions(obj[key], id);
        if (result) {
          return result;
        }
      }
    }

    return null;
  }

  findEventsInsideDrawnRect(drawnRectangle, events, filteredEvents, allNestedTransactions, parentTransactionId) {

    var rectX = drawnRectangle.attr('x');
    var rectY = drawnRectangle.attr('y');
    var rectWidth = drawnRectangle.attr('width');
    var rectHeight = drawnRectangle.attr('height');
    let nestedTxnInDrawnRect = []; // List of nested transactions inside the drawn rectangle
    const eventsInsideRect = [];
    const resultArray = [];
    const invokedInsideNested = [];

    const filteredEventsIds = new Set(filteredEvents.map((event) => event._id));
    const parentTransaction = this.props.allTransactions.find((pTr) => pTr._id == parentTransactionId);

    // Finding all nested transactions inside the drawn rectangle
    nestedTxnInDrawnRect = allNestedTransactions.filter((txnRect) => {
      if (isRectangleContained(txnRect?.rect, drawnRectangle)) {
        return txnRect;
      }
      return false;
    });

   
    // Finding all invoked transactions inside the drawn rectangle
    this.drawnChildInvokedTransactions.forEach((drawnRect) => {
      const isParentSame = parentTransaction?.invokedTransactions.some(item => item.id == drawnRect.id) || false;
      if (this.isRectInside(drawnRect, drawnRectangle) && isParentSame) {
        invokedInsideNested.push(drawnRect);
      }
    });

    // Find the transaction details of all nestedTxnDrawnRect. SVG Data --> Transaction details in DB
    const nestedTxnInDrawnDetails = this.props.allTransactions.filter((mainObj) => {
      return mainObj.type == 9 && nestedTxnInDrawnRect.some((innerObj) => innerObj.id == mainObj._id)
    });

    // Filtering out all the nested transaction that is inside the selected transactions for finding only level 1 nested transactions
    const actualContainedNestedTxns = nestedTxnInDrawnRect.filter((rectangle) => {
      return !nestedTxnInDrawnDetails.some((transaction) => transaction.nestedTransactions.some((nestedTransaction) => nestedTransaction.id === rectangle.id));
    });


    let nestedOnly = this.props.allTransactions.filter((tr) => tr.type == 9);
    for (const rapselItem of actualContainedNestedTxns) {
      const idToFind = rapselItem.id;

      for (const nestedObj of nestedOnly) {
        const nestedTransactions = this.findNestedTransactions(nestedObj, idToFind);

        if (nestedTransactions) {
          resultArray.push(...nestedTransactions);
        }
      }
    }

    
    let recursiveChildTrans = [...actualContainedNestedTxns, ...resultArray];

    for (var i = 0; i < events.length; i++) {
      var event = events[i];
      var eventPositionY = event.positionY;

      if (eventPositionY >= rectY && eventPositionY <= rectY + rectHeight) {
        let eventInsideNested = this.isInsideNestedTransaction(eventPositionY);


        if (eventInsideNested != undefined && recursiveChildTrans?.length > 0) {
          let foundRect = recursiveChildTrans.find((ch) => ch.id == eventInsideNested?.id);
          let eventInsideParent = parentTransaction != undefined ? parentTransaction?.events?.some((ev) => ev.id == event?.id) : '';

          if (foundRect == undefined && eventInsideParent != '') {
            eventsInsideRect.push(event);
          }
        } else {
          eventsInsideRect.push(event);
        }
      }
    }

    const filteredDrawnevnt = eventsInsideRect.filter((event) => filteredEventsIds.has(event.id));

    return { filteredDrawnevnt, childTransInsideNested: actualContainedNestedTxns, invokedInsideNested };
  }

  generateOrderedEvents(events) {
    let ordereEvents = [];

    events.forEach((ev) => {
      let order = this.generateOrder(ev.positionY);
      if (order != undefined) {
        const evObj = {
          id: ev.id,
          order: order,
        };

        ordereEvents.push(evObj);
      }
    });

    return ordereEvents;
  }

  generateOrderedNestedTrans(raphaelNestedTransaction) {
    let ordereNested = [];

    raphaelNestedTransaction.forEach((tr) => {
      let order = this.generateOrder(tr.rect.attr('y'));
      if (order != undefined) {
        const evObj = {
          id: tr.id,
          order: order,
        };

        ordereNested.push(evObj);
      }
    });

    return ordereNested;
  }

  onArrowClick = ({ arrow, text }, data) => {
    // if (arrow) arrow.remove();
    // if (text) text.remove();
    if (data) this.setState({ arrowPayload: { edit: true, ...data } });
  };

  //Check if the start or end node is a template clusterlet
  isAssociatedWithTemplate = (item) => {
    let res = this.props.eventViewProps.templatedClusterlets.find((t) => t.id == item.startClusterlet.id || t.id == item.endClusterlet.id);

    if (res == null || res == undefined) return false;

    return true;
  };

  onMouseMoveUp = () => {
    //let refinedDrawTransaction = [];

    if (this.arrowPayloadRef?.position === undefined && this.arrowPayloadRef?.element == undefined) {
      // this.arrowPayloadRef = null;
      const paperElement1 = document.getElementById('papercanvas');
      // paperElement.removeEventListener("mousemove", this.mouseMove);
      // return false;

      if (this.eventPlotPoints.startPoint == null) {
        if (this.arrowPayloadRef == null) {
          const paperElement1 = document.getElementById('papercanvas');
          paperElement1.removeEventListener('mousemove', this.mouseMove);
          if (this.startPlotPoint != null) {
            this.startPlotPoint.remove();
          }
          return false;
        }
        this.eventPlotPoints.startPoint = this.arrowPayloadRef;

        this.startPlotPoint = this.paper.circle(0, 0, 10);
        this.startPlotPoint.attr({ fill: 'green' });
        this.startPlotPoint.toFront();
        this.startPlotPoint.attr({ cx: this.eventPlotPoints.startPoint.downPosition.x, cy: this.eventPlotPoints.startPoint.downPosition.y });

        this.nearestValues = findNearestValues(this.drawnEvents, this.eventPlotPoints.startPoint.downPosition.y);


        const paperElement = document.getElementById('papercanvas');

        paperElement.removeEventListener('mousemove', this.mouseMove);
        //this.currentDrawnEvent = this.arrowPayloadRef.element;
        this.arrowPayloadRef = null;
        this.props.dispatch(setDrawEvent(true));
      } else {
        if (this.arrowPayloadRef == null) {
          const paperElement1 = document.getElementById('papercanvas');
          paperElement1.removeEventListener('mousemove', this.mouseMove);
          if (this.startPlotPoint != null) {
            this.startPlotPoint.remove();
          }
          return false;
        } //this.nearestValues?.nearestGreater?.positionY && mouseY > self.nearestValues?.nearestSmaller?.positionY

        if (this.arrowPayloadRef.downPosition.x == this.eventPlotPoints?.startPoint?.downPosition?.x || this.arrowPayloadRef?.downPosition?.y < this.nearestValues?.nearestSmaller?.positionY || this.arrowPayloadRef?.downPosition?.y > this.nearestValues?.nearestGreater?.positionY) {
          const paperElement = document.getElementById('papercanvas');

          paperElement.removeEventListener('mousemove', this.mouseMove);
          return false;
        }

        this.eventPlotPoints.endPoint = this.arrowPayloadRef;
        const element = this.paper.path(this.eventPlotPoints.startPoint.aPath);

        element.attr(eventAttributes);

        let upXVal = this.findTheCloset(this.eventPlotPoints.endPoint.downPosition.x);
        const upYVal = this.eventPlotPoints.startPoint.downPosition.y;

        const endClusterlet = this.findTheClusterlet(upXVal);

        const paperElement = document.getElementById('papercanvas');

        /** If connection not established in system model, DO NOT ALLOW that */
        let validConnection = checkValidConnection({ src: this.eventPlotPoints.startPoint.startClusterlet?.id, dst: endClusterlet?.id, smConnections: this.props.smConnections });
        if (validConnection === false) {
          this.startPlotPoint.remove();
          this.arrowPayloadRef = null;
          element.remove();
          paperElement.removeEventListener('mousemove', this.mouseMove);
          this.props.dispatch(handleSnackBar({ open: true, message: `Connection not found between clusterlets ${this.eventPlotPoints.startPoint.startClusterlet.name} and ${endClusterlet.name} in system model`, severity: 'error' }));
          return;
        }

        const path = 'M' + this.eventPlotPoints.startPoint.downPosition.x + ' ' + this.eventPlotPoints.startPoint.downPosition.y + 'L' + (upXVal > 0 ? upXVal : 0) + ' ' + (upYVal > 0 ? upYVal : 0);

        element.attr('path', path);

        // this.arrowPayloadRef = { ...this.arrowPayloadRef, element, endClusterlet, position: { y: this.eventPlotPoints.startPoint.downPosition.y, x: upXVal }, attr: { ...((this.arrowPayloadRef && this.arrowPayloadRef.attr) || {}), path } };
        let order = this.generateOrder(this.eventPlotPoints.endPoint.downPosition.y);
        let item = { ...this.arrowPayloadRef, order, drawnChildTransactions: this.drawnChildTransactions };

        const newElement = item.element;
        const newItem = {
          startClusterlet: this.eventPlotPoints.startPoint.startClusterlet,
          endClusterlet: endClusterlet,
          order: item.order,
          position: this.eventPlotPoints.endPoint.downPosition,
          element: element.attrs,
          drawnChildTransactions: this.drawnChildTransactions.map((t) => ({ id: t.id, y: t.y, height: t.height })),
        };
        this.props.dispatch(setTabOnFocus(0));
        this.props.dispatch(setFocusElement({ id: null, item: newItem, type: 'event', name: 'Create event' }));
        this.props.dispatch(toggleRightDrawer());

        // setting drawing mode off
        this.props.dispatch(setDrawEvent(false));
        this.props.dispatch(setDrawNestedTransaction(false));
        this.props.dispatch(setDrawReuseTransaction(false));
        this.props.dispatch(setDrawTemplateTransaction(false));
        this.enablePan();

        //this.addArrow(this.arrowPayloadRef);
        paperElement.removeEventListener('mousemove', this.mouseMove);
        this.currentDrawnEvent = this.arrowPayloadRef.element;
        this.arrowPayloadRef = null;
        // this.props.dispatch(setDrawEvent(true));
        this.eventPlotPoints.startPoint = null;
        this.eventPlotPoints.endPoint = null;
      }
    } else {
      let order = this.generateOrder(this.arrowPayloadRef.position.y);
      let item = { ...this.arrowPayloadRef, order, drawnChildTransactions: this.drawnChildTransactions };

      /** If connection not established in system model, DO NOT ALLOW that */
      let validConnection = checkValidConnection({ src: item?.startClusterlet?.id, dst: item?.endClusterlet?.id, smConnections: this.props.smConnections });
      if (validConnection === false) {
        this.arrowPayloadRef.element.remove();
        this.props.dispatch(handleSnackBar({ open: true, message: `Connection not found between clusterlets ${item.startClusterlet.name} and ${item.endClusterlet.name} in system model`, severity: 'error', autoHideDuration: 2000 }));
        return;
      }

      /** If drawn to/from a template, DO NOT ALLOW that */
      if (this.isAssociatedWithTemplate(item)) {
        this.arrowPayloadRef.element.remove();
        this.props.dispatch(handleSnackBar({ message: 'Cannot associate new events to a template', severity: 'error' }));
        return false;
      }

      const element = item.element;
      const newItem = {
        startClusterlet: item.startClusterlet,
        endClusterlet: item.endClusterlet,
        order: item.order,
        position: item.position,
        element: element.attrs,
        drawnChildTransactions: this.drawnChildTransactions.map((t) => ({ id: t.id, y: t.y, height: t.rect?.attrs?.height, x: t.rect?.attrs?.x, width: t.rect?.attrs?.width })),
      };

      this.props.dispatch(setTabOnFocus(0));
      this.props.dispatch(setFocusElement({ id: null, item: newItem, type: 'event', name: 'Create Event' }));
      this.props.dispatch(toggleRightDrawer());

      // setting drawing mode off
      this.props.dispatch(setDrawEvent(false));
      this.props.dispatch(setDrawNestedTransaction(false));
      this.props.dispatch(setDrawReuseTransaction(false));
      this.props.dispatch(setDrawTemplateTransaction(false));
      this.enablePan();

      const paperElement = document.getElementById('papercanvas');
      //this.addArrow(this.arrowPayloadRef);
      paperElement.removeEventListener('mousemove', this.mouseMove);
      this.currentDrawnEvent = this.arrowPayloadRef.element;
      this.arrowPayloadRef = null;
      // this.props.dispatch(setDrawEvent(true));
    }
  };

  /** Is given Y position with in the limits of an invoked transaction */
  isInsideInvokedTransaction = (positionY) => {
    let invokedT = this.drawnChildInvokedTransactions.find((t) => {
      return t.rect.attr('y') <= positionY && positionY <= t.rect.attr('height') + t.rect.attr('y');
    });
    return invokedT;
  };

  isNestedRectInside(outerRect, innerRect) {
    const outerBox = outerRect.getBBox();
    const innerBox = innerRect.getBBox();

    return innerBox.x >= outerBox.x && innerBox.y >= outerBox.y && innerBox.x + innerBox.width <= outerBox.x + outerBox.width && innerBox.y + innerBox.height <= outerBox.y + outerBox.height;
  }

  sortByNesting(rectangles) {
    const nestingMap = new Map();

    rectangles.forEach((rect) => {
      const nestingLevel = rectangles.filter((r) => this.isNestedRectInside(r.rect, rect.rect)).length;
      if (!nestingMap.has(nestingLevel)) {
        nestingMap.set(nestingLevel, []);
      }
      nestingMap.get(nestingLevel).push(rect);
    });

    const sortedRectangles = [];
    for (const [, rects] of nestingMap) {
      sortedRectangles.push(...rects);
    }

    return sortedRectangles;
  }

  /** Is given Y position with in the limits of a nested transaction */
  isInsideNestedTransaction = (positionY) => {
    let sortedNestedArray = [...this.drawnChildNestedTransactions];

    sortedNestedArray.sort((a, b) => {
      if (a.rect.attr('y') !== b.rect.attr('y')) {
        return b.rect.attr('y') - a.rect.attr('y'); // Sort by 'y' in ascending order
      }
      //  else {
      //     return a.rect.attr('height') - b.rect.attr('height'); // If 'y' is the same, sort by 'height' in ascending order
      // }
    });

    // const sortedRectangles = this.sortByNesting(sortedNestedArray);


    // let nestedT = this.drawnChildNestedTransactions.find(t => {
    //     return (t.rect.attr('y') <= positionY && positionY <= t.rect.attr('height') + t.rect.attr('y'))
    // })

    let nestedT = sortedNestedArray.find((t) => {
      return t.rect.attr('y') <= positionY && positionY <= t.rect.attr('height') + t.rect.attr('y');
    });
    return nestedT;
  };

  isInsideChildTransaction = (positionY, rectHeight) => {
    let sortedNestedArray = [...this.drawnChildNestedTransactions];

    sortedNestedArray.sort((a, b) => {
      if (a.rect.attr('y') !== b.rect.attr('y')) {
        return b.rect.attr('y') - a.rect.attr('y'); // Sort by 'y' in ascending order
      }
      //  else {
      //     return a.rect.attr('height') - b.rect.attr('height'); // If 'y' is the same, sort by 'height' in ascending order
      // }
    });


    // console.log('sortedNestedArray--->', sortedNestedArray, this.drawnChildNestedTransactions);
    // console.log('sortedNestedArray---2>', positionY);

    // let nestedT = this.drawnChildNestedTransactions.find(t => {
    //     return (t.rect.attr('y') <= positionY && positionY <= t.rect.attr('height') + t.rect.attr('y'))
    // })

    let nestedT = sortedNestedArray.find((t) => {
      return t.rect.attr('y') <= positionY && positionY + rectHeight <= t.rect.attr('height') + t.rect.attr('y');
    });
    return nestedT;
  };

  isFullyInsideRect = (positionY) => {
    let sortedNestedArray = [...this.drawnChildNestedTransactions];
  
    sortedNestedArray.sort((a, b) => {
      if (a.rect.attr('y') !== b.rect.attr('y')) {
        return b.rect.attr('y') - a.rect.attr('y'); // Sort by 'y' in ascending order
      }
    });

    let nestedT = sortedNestedArray.find((t) => {
      return t.rect.attr('y') < positionY && positionY < t.rect.attr('height') + t.rect.attr('y');
    });

    return nestedT;
  };

  /** Is given Y position with in the limits of templated transaction */
  isInsideTemplatedTransaction = (positionY) => {
    let templatedT = this.drawnTemplatedTransactions.find((t) => {
      return t.rect.attr('y') <= positionY && positionY <= t.rect.attr('height') + t.rect.attr('y');
    });
    return templatedT;
  };

  /** Track event drawing as the user moves mouse clicked */
  trackEventDrawingMove = (e) => {
    const paperElement = document.getElementById('papercanvas');
    const self = this;
    e.preventDefault();

    self.arrowPayloadRef = {};

    let mouseDownX = e.pageX - self.getOffet(paperElement).left;
    const mouseDownY = e.pageY - self.getOffet(paperElement).top;

    let isInsideInvoked = self.isInsideInvokedTransaction(mouseDownY);
    if (isInsideInvoked !== undefined) {
      this.props.dispatch(handleSnackBar({ open: true, message: 'Cannot add an event in an invoked transaction', severity: 'error' }));
      return;
    }

    let isInsideTemplated = self.isInsideTemplatedTransaction(mouseDownY);
    if (isInsideTemplated !== undefined) {
      this.props.dispatch(handleSnackBar({ open: true, message: 'Cannot add an event in a template transaction', severity: 'error' }));
      self.props.eventViewProps.resetTransaction();
      return;
    }

    // console.log('this.drawnRectangles--------->', this.drawnRectangles);
    const points = this.drawnRectangles.map((c) => c.drawnObj.attr('x'));
    const min = Math.min(...points);
    const max = Math.max(...points);

    if (mouseDownX <= min) return;

    const allowedCondition = mouseDownY >= this.heightOfRectangle;

    if (!allowedCondition) return;

    mouseDownX = this.findTheCloset(mouseDownX);

    if (!mouseDownX) return;

    const startClusterlet = this.findTheClusterlet(mouseDownX);
    const aPath = 'M' + mouseDownX + ' ' + mouseDownY;
    self.arrowPayloadRef = { aPath };
    const element = self.paper.path(aPath);

    const { eventViewProps: { addAlreadyCreatedTransaction: addTransction } = {} } = self.props;
    element.attr(eventAttributes1);

    self.arrowPayloadRef = { ...self.arrowPayloadRef, isTransction: addTransction, startClusterlet, attr: eventAttributes, downPosition: { x: mouseDownX, y: mouseDownY } };

    function mouseMove(event) {
      element.attr(eventAttributes);

      let upX = event.pageX - self.getOffet(paperElement).left;
      if (upX > max) return;
      upX = self.findTheCloset(upX);

      const endClusterlet = self.findTheClusterlet(upX);

      const upY = mouseDownY || event.pageY - self.getOffet(paperElement).top;

      const path = 'M' + mouseDownX + ' ' + mouseDownY + 'L' + (upX > 0 ? upX : 0) + ' ' + (upY > 0 ? upY : 0);

      element.attr('path', path);

      self.arrowPayloadRef = { ...self.arrowPayloadRef, element, endClusterlet, position: { y: mouseDownY, x: upX }, attr: { ...((self.arrowPayloadRef && self.arrowPayloadRef.attr) || {}), path } };
    }

    this.mouseMove = mouseMove;
    paperElement.addEventListener('mouseup', self.onMouseMoveUp, true);
    paperElement.addEventListener('mousemove', mouseMove);
  };

  /** Track transaction drawing as the user moves mouse clicked */
  trackTransactionDrawingMove = (e) => {
    const { addEvent, drawTransaction } = this.props.eventViewProps;

    const paperElement = document.getElementById('papercanvas');
    const self = this;
    e.preventDefault();

    let mouseDownX = e.pageX - self.getOffet(paperElement).left;
    const mouseDownY = e.pageY - self.getOffet(paperElement).top;

    let positionY = this.generateOrder(mouseDownY);

    /* Cannot allow to draw a transaction inside an invoked one */
    let isInsideInvoked = self.isInsideInvokedTransaction(mouseDownY);
    if (isInsideInvoked !== undefined) {
      this.props.dispatch(handleSnackBar({ open: true, message: 'Cannot add a transaction in an invoked transaction', severity: 'error' }));
      self.props.eventViewProps.resetTransaction();
      return;
    }

    /* Cannot allow to draw a transaction inside a nested one */
    // let isInsideNested = self.isInsideNestedTransaction(mouseDownY)
    // if (isInsideNested !== undefined) {
    //     this.props.dispatch(handleSnackBar({ open: true, message: "Cannot add a transaction in a nested transaction", severity: "error" }));
    //     self.props.eventViewProps.resetTransaction()
    //     return
    // }

    /** Cannot allow to draw a transaction inside a templated Transaction */
    let isInsideTemplated = self.isInsideTemplatedTransaction(mouseDownY);
    if (isInsideTemplated !== undefined) {
      this.props.dispatch(handleSnackBar({ open: true, message: 'Cannot add an event in a template transaction', severity: 'error' }));
      self.props.eventViewProps.resetTransaction();
      return;
    }

    mouseDownX = this.findTheCloset(mouseDownX);

    if (!mouseDownX) return;

    const startClusterlet = this.findTheClusterlet(mouseDownX);


    const { selected } = this.props;
    const { first, last } = this.firstNlastClusterlets(selected.clusterlets);

    // const source = this.drawnRectangles.find((item) => item.id === first.id)
    const source = this.drawnRectangles.find((item) => item.id === startClusterlet.id);

    // const dest = this.drawnRectangles.find((item) => item.id === last.id)

    // if (source == undefined || dest == undefined) return false;

    const x = source.drawnObj.attr('x') + this.widthOfRectangle / 2 - 10;
    const height = 2;
    const width = 2;

    var pcanvas = document.getElementById('papercanvas');
    var canvasRect = pcanvas.getBoundingClientRect();

    //const rect = self.paper.rect(x, mouseDownY, width, height)
    const rect = self.paper.rect(e.pageX - canvasRect.left, mouseDownY, width, height);
    rect.attr(drawingTrackingTransactionConfig);

    /** Mouse move */
    function mouseMove(event) {
      var pcanvas = document.getElementById('papercanvas');
      var canvasRect = pcanvas.getBoundingClientRect();

      let xPos = event.pageX - self.getOffet(paperElement).left;

      xPos = self.findTheCloset(xPos);

      const endClusterlet = self.findTheClusterlet(xPos);

      const destClusterlet = self.drawnRectangles.find((item) => item.id === endClusterlet.id);

      let targetX = destClusterlet.drawnObj.attr('x') + self.widthOfRectangle / 2;
      let newWidth = targetX + 18;
      // console.log('pos--------->', self.mosusePosY, event.clientY, newWidth);

      //rect.attr({ width: newWidth + 10 - x, height: event.offsetY - self.getOffet(paperElement).top })
      rect.attr({ width: event.pageX - canvasRect.left - rect.attr('x'), height: event.pageY - canvasRect.top - rect.attr('y') });

      const nodePositions = self.drawnRectangles.map(item => item.drawnObj.attrs.x).filter(item => item != undefined);
     
      const lastNodePosition = Math.max(...nodePositions);
      const currentCursorPosition = event.pageX - self.getOffet(paperElement).left;
     
      // To open the child transaction create modal when mouse reaches last node position + 2 node width
      if (currentCursorPosition > (lastNodePosition + (self.widthOfRectangle * 2))) {
        openChildTransactionModal(event, endClusterlet, destClusterlet);
      }
      
    }

    /** Mouse up */
    function mouseUp(event) {
      let xPos = event.pageX - self.getOffet(paperElement).left + 20;
      xPos = self.findTheCloset(xPos);
      const endClusterlet = self.findTheClusterlet(xPos);

      const destClusterlet = self.drawnRectangles.find((item) => item.id === endClusterlet.id);


      openChildTransactionModal(event, endClusterlet, destClusterlet);
     
    }


    function openChildTransactionModal(event, endClusterlet, destClusterlet) {

      if (startClusterlet?.id == endClusterlet?.id) {
        self.props.dispatch(handleSnackBar({ open: true, message: `Minimum two nodes required to draw a nested transaction`, severity: 'error' }));
        // self.props.eventViewProps.resetTransaction()
        // clearMouseEvent()
        rect.remove();
        // self.props.dispatch(setDrawnTransaction(true))
        self.props.dispatch(reRenderInfoBuilder());
        self.props.dispatch(setDrawNestedTransaction(false));
        return;
      }
      let filteredRects = self.findClusterletsOfNestedTransaction(rect);

      let clusterletsWithOrder = self.clusterletsWithOrder(filteredRects);
      let filteredEvents = self.getEventsWithMatchingClusterlets(self.props.allEvents, filteredRects);

      let isInsideNested = self.isInsideChildTransaction(rect.attr('y'), rect.attr('height'));
      if (isInsideNested != undefined) {
        self.props.dispatch(setParentTransaction(isInsideNested?.id));
      } else {
        self.props.dispatch(setParentTransaction(''));
      }
      const parentTransaction = isInsideNested ? isInsideNested : self.props.selected?._id;
      let { filteredDrawnevnt, childTransInsideNested, invokedInsideNested } = self.findEventsInsideDrawnRect(rect, self.drawnEvents, filteredEvents, self.drawnChildNestedTransactions, parentTransaction);

      let orderedEvents = self.generateOrderedEvents(filteredDrawnevnt);
      let orderedChildNested = self.generateOrderedNestedTrans(childTransInsideNested);
      let orderedChildInvoked = self.generateOrderedNestedTrans(invokedInsideNested);

      self.props.dispatch(setDrawnTransaction(true));
      self.props.dispatch(setNestedTransactionEvents(orderedEvents));
      self.props.dispatch(setNestedTransactionClusterlets(clusterletsWithOrder));
      self.props.dispatch(setNestedTransactionChildren(orderedChildNested));
      self.props.dispatch(setNestedTransactionInvoked(orderedChildInvoked));   
      self.props.eventViewProps.resetTransaction();
      clearMouseEvent();
      let targetX = destClusterlet.drawnObj.attr('x') + self.widthOfRectangle / 2 + 10;

      var pcanvas = document.getElementById('papercanvas');
      var canvasRect = pcanvas.getBoundingClientRect();

      rect.attr({ width: event.pageX - canvasRect.left - rect.attr('x') });

      self.props.eventViewProps.setIntermediateTransactionBlock(rect); // saving data so that we can remove the box when closing the transaction popup

      self.props.eventViewProps.setTransactionYPosition(positionY);
      self.props.eventViewProps.onToggleTranction(null, rect); //passing rect to HOC
      paperElement.removeEventListener('mouseup', mouseUp);
    }

    /** Clear mouse event */
    function clearMouseEvent() {
      const paperElement = document.getElementById('papercanvas');
      paperElement.removeEventListener('mousemove', mouseMove);
    }

    /** Bind functions to paper */
    paperElement.addEventListener('mousemove', mouseMove);
    paperElement.addEventListener('mouseup', mouseUp);
  };

  /** Generate element order */
  generateOrder = (mouseDownY) => {
    const items = [
      ...this.drawnEvents.map((e) => ({ id: e.id, y: e.positionY })),
      ...this.drawnChildTransactions.map((t) => ({ id: t.id, y: t.y })),
      ...this.drawnChildInvokedTransactions.map((t) => ({ id: t.id, y: t.y })),
      ...this.drawnTemplatedTransactions.map((t) => ({ id: t.name, y: t.rect.attr('y') })),
    ];


    let borderEl = getBorderElement(mouseDownY, items);


    const initialOrder = 500;

    /** No previous elements */
    if (borderEl == false) {
      return initialOrder;
    }

    if (borderEl === undefined || borderEl == null) {
      /** Greater than all previous */
      let lastID = items[items.length - 1].id;
      let order = this.findOrderFromId(lastID);
      return order + 100;
    } else {
      // console.log('else-------------');

      /* In between two drawn elements */
      let order = this.findOrderFromId(borderEl.id);
      let prevEl = getPreviousElement(borderEl.y, items);


      console.log("prevEl-----,", prevEl)

      if (prevEl == false) {
        return order - 100;
      }

      let prevOrder = this.findOrderFromId(prevEl.id);

      if (prevOrder == order) {
        return prevOrder / 2;
      }

      console.log("ordrs----", { prevOrder, order })
      return prevOrder + (order - prevOrder) / 2;
    }
  };

  /** Find order of element from ID */
  findOrderFromId = (id) => {
    // console.log('id----->,,', id);

    const {
      nestedTRansactions,
      selected: { events, nestedTransactions, invokedTransactions, templateTransactions },
    } = this.props;

    // console.log('nest------->', nestedTransactions);

    let allNested = this.props.allTransactions.filter((tr) => tr.type == 9);

    // let trnsEvnts = [];

    // this.props.allTransactions.forEach(tr => {
    //     trnsEvnts = [...trnsEvnts, ...tr.events]
    // })

    let nestedEvents = [];
    // nestedTRansactions.forEach(t => {
    //     //nestedEvents = [ ...nestedEvents, [ ...t.events ] ]
    //     t.events.forEach(e => { nestedEvents.push(e) })
    // })
    allNested.forEach((t) => {
      //nestedEvents = [ ...nestedEvents, [ ...t.events ] ]
      t.events.forEach((e) => {
        nestedEvents.push(e);
      });
    });

    let allNestedTransactions = [];
    this.props.allTransactions.forEach((n) => {
      allNestedTransactions = [...allNestedTransactions, ...n.nestedTransactions];
    });


    const items = [...events, ...allNestedTransactions, ...invokedTransactions, ...nestedEvents, ...templateTransactions];

    /* events */
    let el = items.find((item) => item?.id == id || item?.name == id);
    // console.log('el--------->', el);
    if (el !== undefined && el != null) return el.order;
  };

  /** Find order of element from Nested Transaction */
  getChildrenFromAllNestedTransactions = () => {
    const { selected } = this.prop;
  };

  /** Listens for mouse down+move, then drawn an event or transaction */
  onMouseDown = (e) => {
    try {
      const { drawEvent, drawNestedTransaction, drawReuseTransaction, drawTemplateTransaction } = this.props.eventViewProps.transactionState;
      const paperElement = document.getElementById('papercanvas');

      if (drawEvent) this.trackEventDrawingMove(e);
      else if (drawNestedTransaction || drawReuseTransaction || drawTemplateTransaction) this.trackTransactionDrawingMove(e);
    } catch (error) {
      log(error, '[onMouseDown]');
    }
  };

  findisArrowInsideAnEmbebdedTransaction = (arrow) => {
    const index = (this.embeddedTransactions || []).findIndex((i) => {
      const attr = i.element.attrs;
      const lowerLimit = attr.y;
      const upperLimit = attr.y + attr.height;
      const currentValues = arrow.position.y;
      const condition = currentValues >= lowerLimit && currentValues <= upperLimit;
      if (condition) return true;
      return false;
    });
    return index;
  };

  addArrow = (arrow) => {
    const isArrowInsideAnEmbebdedTransaction = this.findisArrowInsideAnEmbebdedTransaction(arrow);
    const { eventViewProps } = this.props;
    if (!arrow.uuid) arrow.uuid = uuid.generate();

    if (isArrowInsideAnEmbebdedTransaction > -1) arrow.isWithEmbeddedTransaction = (this.embeddedTransactions || [])[isArrowInsideAnEmbebdedTransaction].uuid;

    const paperElement = document.getElementById('papercanvas');

    this.setState({ arrowPayload: arrow });

    paperElement.removeEventListener('mouseup', this.onMouseMoveUp, true);
    //if (eventViewProps && eventViewProps.addEvent && eventViewProps.onToggle) eventViewProps.onToggle();
    //if (eventViewProps && eventViewProps.addTransction && eventViewProps.onToggle) eventViewProps.onToggleTranction();
  };

  closeEventView = (arrow) => {
    this.setState({ arrowPayload: null });
    if (arrow) arrow.remove();
  };

  rerender() {
    this.props.dispatch(reRenderInfoBuilder());
  }

  editEventClose = () => {
    /*this.props.dispatch(setSelectedEvent(null))*/
  };

  disablePan = () => {
    this.props.dispatch(setDisablePan(true));
    if (this.startPlotPoint != null) {
      this.startPlotPoint.remove();
    }
    this.eventPlotPoints.startPoint = null;
    this.eventPlotPoints.endPoint = null;
  };

  enablePan = () => {
    this.props.dispatch(setDisablePan(false));
    if (this.startPlotPoint != null) {
      this.startPlotPoint.remove();
    }

    this.eventPlotPoints.startPoint = null;
    this.eventPlotPoints.endPoint = null;
    // if (this.moveListener !== null) {
    // this.moveListener.remove();
    // }
  };

  newPaperHeight = () => {
    let heightOfPaper = window.screen.height - 230;
    if (this.lastDrawnY != null && this.lastDrawnY + 400 > heightOfPaper) {
      heightOfPaper = this.lastDrawnY + 400;
    }

    return heightOfPaper;
  };

  render() {
    const { width, arrowPayload, codeEditorView, height } = this.state;
    const { eventViewProps } = this.props;
    const { addEvent, addTransction, addAlreadyCreatedTransaction, drawTransaction } = eventViewProps;

    const heightOfPaper = this.newPaperHeight();

    if (this.paper != null) {
      this.paper.setSize('100%', heightOfPaper);
    }

    //backgroundImage: "url(" + ImgGrid + ")"


    let style = {
      backgroundImage: `url(${ImgGrid})`,
      // overflow: 'scroll',
      border: '2px solid #ccc',
      //height: window.screen.height - 230,
      height: heightOfPaper,
      //width: this.drawnRectangles.length * (this.widthOfRectangle * 2) + this.widthOfRectangle,
      '-webkit-transform-origin': '0 0',
      width: 4000, // this.drawnRectangles.length * transactionWidth
    };

    let paperStyle = {
      padding: 30,
    };

    //{...style, cursor: enableMouseDraw? `url(${PencilIcon}), auto`: 'pointer'}

    let enableMouseDraw = this.props.transactionState.drawEvent || this.props.transactionState.drawNestedTransaction || this.props.transactionState.drawReuseTransaction || this.props.transactionState.drawTemplateTransaction;
    const popEventForm = () => arrowPayload && arrowPayload?.startClusterlet && arrowPayload?.endClusterlet;

    return (
      <Fragment>
        <Grid container direction="row" justify="center" alignItems="center" style={paperStyle}>
          <TransformWrapper disabled2={this.props.rfPanDisableStatus} minScale={0.7} disabled={true}>
            {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
              <>
                <TransformComponent>
                  <Grid item style={style} onMouseDown={enableMouseDraw ? this.onMouseDown : null} id="papercanvas" />
                </TransformComponent>

                <TransactionZoomOptions
                  zoomIn={(e) => {
                    zoomIn();
                  }}
                  zoomOut={(e) => {
                    zoomOut();
                  }}
                  reset={(e) => {
                    resetTransform();
                  }}
                />
                <TransactionSpeedDial reset={resetTransform} disable={this.disablePan} />
                <DisableDrawingModeButton enable={this.enablePan} />
              </>
            )}
          </TransformWrapper>
        </Grid>
      </Fragment>
    );
  }
}

const connectStateToProps = (state) => {
  let selected = getSelectedTransactions(state);
  const transction = getTransaction(state);
  // const elements = getClusterlets(state);
  const elements = getBlueprintData('clusterlets');
  // const smConnections = getClusterletConnections(state);
  const smConnections = [];
  const events = getEvents(state);
  const nestedTRansactions = getNestedTransactions(state);
  const selectedEvent = getSelectedEvent(state);
  let forRerender = false;

  const allEvents = getAllEvents(state);
  const rightDrawerStatus = getRightDrawerStatus(state);
  const transactionState = getTransactionState(state);
  const allTransactions = getAllTransactions(state);
  const rfPanDisableStatus = getDisablePanStatus(state);

  const templatedClusterlets = getTemplateClusterlets(state);
  const reRenderDf = getReRender(state);
  const codeEditStatus = getCodeEditStatus(state);

  return { selected, transction, reRender: getRenderCount(state), elements, events, nestedTRansactions, selectedEvent, allEvents, rightDrawerStatus, transactionState, allTransactions, rfPanDisableStatus, templatedClusterlets, smConnections, reRenderDf, codeEditStatus };
};

const Wrapper = (Wrapped) => {
  const HOC = (props) => {
    const history = useHistory();
    const [addAlreadyCreatedTransaction, setAddCreatedTransaction] = React.useState(false);
    const [addEvent, setAddEvent] = React.useState(false);
    const [addTransction, setTransction] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const onClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);
    const [componentreRender, setcomponentreRender] = React.useState({ status: false });
    const [drawTransaction, setDrawTransaction] = React.useState(false);
    const [transactionYPosition, setTransactionYPosition] = React.useState(0);
    const [intermediateTransactionBlock, setIntermediateTransactionBlock] = React.useState(null);
    const [openMainTransaction, setOpenMainTransaction] = React.useState(false);
    const [drawingRect, setDrawingRect] = React.useState(null);
    const [showCreateButton, setShowCreateButton] = React.useState(true);
    const [showNotFound, setShowNotFound] = React.useState(false);
    const [transactionsFromApi, setTransactionsFromApi] = React.useState([]);
    const [transactionEventsFromAPI, setTransactionEvents] = React.useState([]);
    const [clusterletsFromAPI, setClusterletsFromAPI] = React.useState([]);
    const [nestedFromAPI, setNestedFromAPI] = React.useState([]);
    const [allTrans, setAllTrans] = useState([]);
    const [connectionFromApi, setConnectionsFromApi] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [noTransFound, setNoTransFound] = useState(false);
    const currentUrl = window.location.href;
    const [slug, blueprintID, tag, transactionId] = currentUrl.split('/').slice(4);
    const [allEvents, setAllEvents] = useState([]);
    const [allMessages, setAllMessages] = useState([]);
    const [allFields, setAllFields] = useState([]);

    const params = useParams();

    const { transction, reRender, dispatch, selected, selectedEvent, transactionState, elements, allTransactions, templatedClusterlets, reRenderDf } = props;

    useEffect(() => {
      setIsLoading(true);
      dispatch(invokeGetService('getTransactionAssociates', [params.transaction])).then(async (response) => {
        if (response?.status) {
          console.log('allevents----->', response);
          setNoTransFound(false);
          setTransactionsFromApi([response.data.transaction]);
          setTransactionEvents(response.data.events);
          setClusterletsFromAPI(response.data.clusterlets);
          setNestedFromAPI(response.data.nestedTransactions);
          setAllTrans(response.data.allTransaction);
          setConnectionsFromApi(response.data?.connections);
          setAllEvents(response.data?.allEvents);
          setAllMessages(response.data?.messages);
          setAllFields(response.data?.fields)
        } else if (response?.status == false && response?.code == 255 && response.transactionNotFound == true) {
          setNoTransFound(true);
          setTransactionsFromApi([]);
          dispatch(setInnerScreenRender());
          history.push(`/blueprint/${slug}/${blueprintID}/system-model`);
        }
        setIsLoading(false);
        dispatch(reRenderInfoBuilder());
      });
    }, [reRenderDf, transactionId]);


    let selectedTransaction = transactionsFromApi.find((tr) => tr?._id == params.transaction);


    // useEffect(() => {
    // decideToShowCreateButton(transction, templatedClusterlets);
    // }, [transction])

    useEffect(() => {
      decideToShowCreateButton(transactionsFromApi, templatedClusterlets);
      // if (transactionsFromApi.length == 0) setNoTransFound(true)
      // else setNoTransFound(false)
    }, [transactionsFromApi]);

    const decideToShowCreateButton = (transaction, templatedClusterlets) => {
      if (transaction && transaction?.length > 0) {
        setShowCreateButton(false);
      } else if (templatedClusterlets && templatedClusterlets?.length > 0) {
        setShowCreateButton(false);
      } else if (transaction.length == 0) {
        setShowCreateButton(true);
      }
    };

    if (isLoading) {
      const height = window.innerHeight - (64 + 48 + 30);
      return (
        <>
          <LoaderWithProgress isLoader={true} styleRoot={{ overflow: 'hidden', height }} />
        </>
      );
    }

    // if (selectedTransaction == undefined && !isLoading) {
    // const height = window.innerHeight - (64 + 48 + 30);

    // return (
    // <>
    // <Grid container direction="row" justify="center" alignItems="center" style={{ overflow: "hidden", height }}>
    // <Grid item>
    // </Grid>
    // </Grid>
    // </>
    // );

    // }

    // if (showCreateButton) {

    // const height = window.innerHeight - (64 + 48 + 30);

    // return (
    // <>
    // <Grid container direction="row" justify="center" alignItems="center" style={{ overflow: "hidden", height }}>
    // <Grid item>
    // </Grid>
    // </Grid>
    // </>
    // );
    // }

    // const onClickTransction = (_, option) => {
    // if (!option) return;
    // const { value, ...rest } = option;
    // const item = transction.find((i) => i.id === value);
    // dispatch(setSelectedTransactionId(item.id));
    // };

    // const onChangeTransaction = (e) => {
    // const value = e.target.value
    // const item = transction.find(i => i.id === value);

    // if (item != null) {
    // dispatch(setSelectedTransactionId(value));
    // dispatch(reRenderInfoBuilder())
    // }

    // }

    // if (selectedTransaction == null) {

    // // if (transction?.length > 0) {
    // if (transactionsFromApi?.length > 0) {
    // dispatch(setSelectedTransactionId(transactionsFromApi[0]._id));
    // }
    // }

    const eventViewProps = {
      setSelectedTransction(item) {
        dispatch(setSelectedTransactionId(item.id));
      },
      drawingRect,
      addTransction,
      addEvent,
      addAlreadyCreatedTransaction,
      drawTransaction,
      onToggle() {
        if (addTransction) setTransction((prev) => !prev);
        setAddEvent((prev) => !prev);
        setDrawTransaction(false);
      },
      onToggleTranction(selectedEmebbedId, rect) {
        if (addEvent) setAddEvent((prev) => !prev);
        if (typeof selectedEmebbedId !== 'string') {
          setTransction((prev) => !prev);
          setOpenMainTransaction(true);
        } else setTransction(`draw-${selectedEmebbedId}`); //setting data for open

        if (rect !== undefined) {
          setDrawingRect(rect);
        }
      },
      onToggleAddAlreadyDelcaredTransaction() {
        if (addEvent) setAddEvent((prev) => !prev);
        setAddCreatedTransaction((prev) => !prev);
      },

      resetTransaction() {
        setDrawTransaction(false);
      },

      readyTransactionToDraw() {
        setDrawTransaction((prev) => !prev);
        setAddEvent(false);
        setOpenMainTransaction(false);
      },

      transactionYPosition,
      setTransactionYPosition,
      intermediateTransactionBlock,
      setIntermediateTransactionBlock,

      closeTransactionBox() {
        setDrawTransaction(false);
        setTransction(false);
        removeIntermediateTransactionBlock();

        if (drawingRect != null) drawingRect.remove();
      },

      setFocusElementInternal(payload) {
        dispatch(setFocusElement(payload));
      },

      transactionState,
      allClusterlets: clusterletsFromAPI,
      allTransactions: allTrans,
      templatedClusterlets,
    };

    const removeIntermediateTransactionBlock = () => {
      if (intermediateTransactionBlock != null) intermediateTransactionBlock.remove();
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-node-options-popover' : undefined;

    return (
      <div style={{ marginTop: 75 }}>
        {/* {transction && transction.length ? ( */}
        {transactionsFromApi && transactionsFromApi.length ? (
          <Fragment>
            <Transaction
              // selected={selected}
              selected={selectedTransaction}
              open={eventViewProps.addTransction}
              handleClose={eventViewProps.closeTransactionBox}
              onToggleAddAlreadyDelcaredTransaction={eventViewProps.onToggleAddAlreadyDelcaredTransaction}
              transactionYPosition={transactionYPosition}
              openMainTransaction={openMainTransaction}
            />
          </Fragment>
        ) : null}

        {/* {selected != null && <Delayed dependency={[selected.uuid, reRender, (selected?.arrows || []).length]}>
<Wrapped {...props} selected={selected} eventViewProps={eventViewProps} arrows={selected?.arrows || []} clusterlets={selected?.clusterlets || []} delegates={selected?.delegates || []} analytics={selected?.analytics || []} sensors={selected?.sensors || []} />
</Delayed>} */}
        {selectedTransaction != null && (
          <Delayed dependency={[selectedTransaction.uuid, reRender, (selectedTransaction?.arrows || []).length]}>
            <Wrapped
              {...props}
              elements={clusterletsFromAPI}
              nestedTRansactions={nestedFromAPI}
              allEvents={allEvents}
              events={transactionEventsFromAPI}
              transction={allTrans}
              smConnections={connectionFromApi}
              selected={selectedTransaction}
              allTransactions={allTrans}
              eventViewProps={eventViewProps}
              arrows={selected?.arrows || []}
              clusterlets={selected?.clusterlets || []}
              delegates={selected?.delegates || []}
              analytics={selected?.analytics || []}
              sensors={selected?.sensors || []}
            />
          </Delayed>
        )}
      </div>
    );
  };

  return HOC;
};

export default connect(connectStateToProps)(Wrapper(App));
